import { Component, OnInit, viewChild, ViewChild, TemplateRef } from '@angular/core';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
  AbstractControl,
  FormArray,
  ValidationErrors
} from '@angular/forms';
import {
  CommonModule,
  NgClass,
  AsyncPipe,
  DatePipe,
  formatDate,
} from '@angular/common';
import { ProfileService } from 'src/app/services/api/consumer/profile.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DirectivesModule } from 'src/app/directives.module';
import { BookingsTabComponent } from './bookings-tab/bookings-tab.component';
import { InlineCalendarComponent } from 'src/app/pages/producer/inline-calendar/inline-calendar.component';
import {
  BsDaterangepickerInlineDirective,
  BsDatepickerInputDirective,
  BsDatepickerDirective,
} from 'ngx-bootstrap/datepicker';
import {
  ImageCroppedEvent,
  Dimensions,
  ImageCropperModule,
} from 'ngx-image-cropper';
import {
  NgSelectComponent,
  NgOptionComponent,
  NgOptgroupTemplateDirective,
} from '@ng-select/ng-select';
import { MomentService } from 'src/app/services/api/moment.service';
import moment from 'moment';
import { A, co, el, s } from '@fullcalendar/core/internal-common';
import { QldProfileCompletionComponent } from './qld-profile-completion/qld-profile-completion.component';
import { SchoolData } from 'src/app/models/schoolUser';
import { escape, get } from 'lodash';
import { ArticleComponent } from '../../producer/article/article.component';
import { NgbCalendar, NgbDate, NgbDatepickerModule, NgbModule, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { QuickAvailabilityUpdateComponent } from "../quick-availability-update/quick-availability-update.component";
import { SafeUrlPipe } from './safe-url.pipe';
import { SharedService } from '../../../services/api/message.service';
import { VideoPlayerComponent } from '../../../shared/video-player/video-player.component';
import { ProfileValidatedDictComponent } from "src/app/pages/consumer/profile-validated-dict/profile-validated-dict.component";
import { CommonService } from 'src/app/services/api/common.service';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [
    DirectivesModule,
    CommonModule,
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    AsyncPipe,
    BookingsTabComponent,
    InlineCalendarComponent,
    ImageCropperModule,
    BsDaterangepickerInlineDirective,
    BsDatepickerInputDirective,
    BsDatepickerDirective,
    NgSelectComponent,
    NgOptionComponent,
    NgOptgroupTemplateDirective,
    QldProfileCompletionComponent,
    ArticleComponent,
    NgbDatepickerModule,
    QuickAvailabilityUpdateComponent,
    SafeUrlPipe,
    VideoPlayerComponent,
    ProfileValidatedDictComponent
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent implements OnInit {
  onChildChange(selected: string[]) {
    this.selectedChildren = selected;
    // Patch combined parent+child to experiance_tree
    const combined = Array.from(new Set([...this.selectedParents, ...this.selectedChildren]));
    if (this.roleTypeForm && this.roleTypeForm.get('experiance_tree')) {
      this.roleTypeForm.patchValue({ experiance_tree: combined });
    }
  }
  originalBceWorkStatus: string = '';


  // NSW NESA modal fields
  nswNesaAnswer: string = '';
  nswNesaFirstName: string = '';
  nswNesaLastName: string = '';
  nswNesaDob: string | { year: number; month: number; day: number } | null = null;
  nswNesaId: string = '';
  nswNesaTnc: boolean = false;
  nswNesaPrivacy: boolean = false;
  nswNesaError: string = '';

  plan_to_work_group: boolean = false;
  custom_fields_Cairns_0_CNS: string = '';
  custom_fields_Cairns_0_Previous: string = '';
  custom_fields_Cairns_0_Alternative: string = '';
  editPersonalInformationForm!: FormGroup;
  editStatusForm!: FormGroup;
  existingFileName: string = '';
  showAttachmentError: boolean = false;
  @ViewChild('actionModals') actionModals: any;
  @ViewChild('acceptRequestModal') acceptRequestModal: any;
  @ViewChild('editProfileModal') editProfileModal: any;
  @ViewChild('editStatusModal') editStatusModal: any;
  @ViewChild('editAccreditationModal') editAccreditationModal: any;
  @ViewChild('rightsToWorkModal') rightsToWorkModal: any;
  @ViewChild('skillsModal') skillsModal: any;
  @ViewChild('workExperienceModal') workExperienceModal: any;
  @ViewChild('qualificationsModal') qualificationsModal: any;
  @ViewChild('referenceModal') referenceModal: any;
  @ViewChild('additionalDocumentsModal') additionalDocumentsModal: any;
  @ViewChild('roleTypeModal') roleTypeModal: any;
  @ViewChild('bceQuestionsModal') bceQuestionsModal: any;
  @ViewChild('nswVerificationModal') nswVerificationModal: any;
  @ViewChild('nswVerificationFormModal') nswVerificationFormModal: any;
  @ViewChild('qldVerificationModal') qldVerificationModal: any;
  @ViewChild('hasQCTRegistrationModal') hasQCTRegistrationModal: any;
  @ViewChild('QCTRegistrationFormModal') QCTRegistrationFormModal: any;
  @ViewChild('QCTRegistrationConfirmationModal') QCTRegistrationConfirmationModal: any;
  @ViewChild('bookingsOnboardingModal') bookingsOnboardingModal: any;
  @ViewChild('AccountNotFoundModal') AccountNotFoundModal: any;
  @ViewChild('AccountConflictModal') AccountConflictModal: any;
  @ViewChild(QldProfileCompletionComponent) qldProfileCompletionComp!: QldProfileCompletionComponent;
  @ViewChild('nswNesaModal') nswNesaModal: any;
  @ViewChild('QLDProfileIncompleteModal') QLDProfileIncompleteModal: any;

  // Data sources for async pipe

  private invitesSubject = new BehaviorSubject<any[]>([]);
  private historySubject = new BehaviorSubject<any[]>([]);
  invitesSchoolsList = this.invitesSubject.asObservable();
  invitesHistorySchoolsList = this.historySubject.asObservable();
  availability_healthy: any;

  profileData: any;
  historyData: any[] = [];
  schoolDetails: any[] = [];
  selectAllCheck = false;
  hideButton = true;
  activeTab: 'invites' | 'history' = 'invites';
  currentPage = 1;
  currentHistoryPage = 1;
  schoolLengthLimit = 0;
  schoolHistoryLengthLimit = 0;
  submitted = false;
  schoolCount = 0;
  experiance_tree = [];
  fileName: any;
  addFileName: any;
  selectedAdditionalFile: File | null = null;
  // Forms
  declineInviteForm: FormGroup;
  schoolInvitesFilterForm: FormGroup;
  schoolInvitesHistoryFilterForm: FormGroup;
  actionForm: FormGroup;
  editAccreditationForm!: FormGroup;
  rightsToWorkForm!: FormGroup;
  skillsForm!: FormGroup;
  workExperienceForm!: FormGroup;
  qualificationsForm!: FormGroup;
  additionalDocumentsForm!: FormGroup;
  referenceForm!: FormGroup;
  roleTypeForm!: FormGroup;
  QCTRegistrationForm!: FormGroup;
  onboardingStep = 0;
  // Modal state
  actionType: any;
  schoolName: string = '';
  school: any = null;

  // Character count for decline reason
  ShowLenght = 500;
  ShowLenghtError = 500;
  subjectFilter = [];
  selectedFile: File | null = null;
  fileBase64: string | null = null;
  fileBinary: ArrayBuffer | null = null; // Store binary file

  showMainRoleType = true;
  public_profile_show: boolean = false; // For the second switch
  using_cc_to_B: boolean = false; // For the first switch
  public teachLocalData!: SchoolData | null;
  is_qld_teacher: boolean = false;
  showQldSection: boolean = false;

  notTeacherRoles = [
    'School Administrator',
    'School Principal',
    'HR Manager',
    'School Support Staff',
    'Parent',
    'Student',
    'Education Consultant',
    'Government Official',
    'Recruiter',
    'Other',
  ];
  profileModalData: any;
  qualification_choices: any;
  availability: any;
  all_bce_subjects: any;
  bce_subjects: any;
  expiry_year: any;
  interested_role: any;
  location_preferences: any;
  right_to_work: any;
  roles_interested_in: any;
  subject: any;
  teachingLevels: any;
  CountrySelectorAus: any;
  CountrySelectorNZ: any;
  CountrySelectorSingapore: any;
  countries: any;
  availableStates: any;
  countryStates: any;
  consumer_type_parentTag: any;
  consumer_type_childTag: any;
  consumer_typeStudent: any = [];
  consumer_typeNonTeacher: any = [];
  type_id: string = '';
  showNonTeacherType: boolean = false;
  showUniStudentType: boolean = false;
  iAmTeaching: boolean = false;
  parent_role: any;
  hasQCT: any;
  profileInfo: any;
  showOnboarding: boolean = false;
  QCTConfirmationStatus: any;
  attemptCount: number = 0;
  teacherStatus: boolean = false;
  // EQVerificationStatus: boolean = false;
  qldProfileCompletionPopup: boolean = true;
  introVideo: any = null;
  new_teaching_level: any;

  constructor(
    private ProfileService: ProfileService,
    private router: Router,
    private ngxService: NgxUiLoaderService,
    private fb: FormBuilder,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private toastr: ToastrService,
    private moment: MomentService,
    private _router: Router,
    private sharedService: SharedService,
    private commonService: CommonService
  ) {
    this.declineInviteForm = this.fb.group({});
    this.schoolInvitesFilterForm = this.fb.group({
      filter_name: [''],
      filterType: [''],
      page: [''],
    });
    this.schoolInvitesHistoryFilterForm = this.fb.group({
      filter_name: [''],
      filterType: [''],
      page: [''],
    });
    this.actionForm = this.fb.group({
      action: [''],
      request_id: [''],
      decline_reason: [''],
    });
  }
  // profileCompletion = 15; // percent, set to 15 for your example
  action = '';

  // getSmallProfileDashOffset(availability_health: number): string {
  //   const r = 35;
  //   const circumference = 2 * Math.PI * r;
  //   var adjustedHealth = 100 - availability_health; // Adjusted to subtract 100
  //   const percent = Math.max(0, Math.min(100, adjustedHealth));
  //   const offset = circumference - (circumference * percent) / 100;
  //   return offset.toFixed(3);
  // }

  // getSmallProfileDashArray(_availability_health?: number): string {
  //   const r = 35;
  //   return (2 * Math.PI * r).toFixed(3);
  // }

  // getProfileProgressDashOffset(): string {
  //   // Calculate offset based on profileCompletion, always >= 0
  //   const percent = Math.max(0, Math.min(100, this.profileCompletion));
  //   const circumference = parseFloat(
  //     ProfileComponent.PROFILE_RING_CIRCUMFERENCE
  //   );
  //   const offset = circumference - (circumference * percent) / 100 - 100;
  //   return offset.toFixed(3);
  // }
  // getProfileProgressDashArray(): string {
  //   // Return the circumference for the SVG ring
  //   return ProfileComponent.PROFILE_RING_CIRCUMFERENCE;
  // }
  // static PROFILE_RING_CIRCUMFERENCE = (2 * Math.PI * 35).toFixed(3); // r=35

  ngOnInit(): void {
    this.teachLocalData = JSON.parse(localStorage.getItem('userData') || '{}');
    this.is_qld_teacher = this.teachLocalData?.properties?.is_qld_teacher || false;
    this.loadProfileAPI();
    this.formInIt();
    this.showOnboarding = false;
    this.ProfileService.profileAvailabilityAPI().subscribe({
      next: (res: any) => {
        if (res.status) {
          this.availability = res.data.availability;
          this.availability_healthy = res?.availability_health;
          console.log('Availability data:', res);
          this.ngxService.stop();
        } else {
          this.ngxService.stop();
          this.toastr.error(res.message || 'Failed to load Availability');
        }
      },
      error: (err: any) => {
        this.toastr.error(err.message || 'Failed to load Availability');
        this.ngxService.stop();
      },
    });

  }

  refreshPage() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  formInIt() {
    this.editPersonalInformationForm = this.fb.group({
      teacher_image: [''],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      // previous_lastname: [''],
      gender: ['', Validators.required],
      country: ['', Validators.required],
      address_state: ['', Validators.required],
      address_streetNumber: ['', Validators.required],
      address_streetName: ['', Validators.required],
      address_city: ['', Validators.required],
      address_postalcode: ['', Validators.required],
      mobilephonenumber: ['', [Validators.required, Validators.pattern(/^[\d+\s]+$/),]],
      email: ['', [Validators.required, Validators.email]],
      emergency_contact_name1: [''],
      emergency_contact_name2: [''],
      emergency_contact_relation1: [''],
      emergency_contact_phone1: ['', Validators.pattern(/^[\d+\s]+$/)],
      emergency_contact_phone2: ['', Validators.pattern(/^[\d+\s]+$/)],
      emergency_contact_relation2: [''],
      from: ['profileDetails'],
    });
    this.editStatusForm = this.fb.group({
      status: ['', Validators.required],
      from: 'teacherStatus',
    });

    this.rightsToWorkForm = this.fb.group({
      right_to_work: ['', Validators.required],
      work_start_date: [null],
      from: ['rightToWorkDetails'],
    });
    this.skillsForm = this.fb.group({
      tags: [[]], // Validators will be set dynamically in onParentChange
      experiance_tree: [],
      experience_description: [''],
      video_cv: [''],
      from: 'experienceDetails',
    });
    this.workExperienceForm = this.fb.group({
      job_title: ['', Validators.required],
      school_name: ['', Validators.required],
      from_date: ['', Validators.required],
      to_date: ['', Validators.required],
      experience_summary: ['', Validators.required],
      idx: 'workexperience-New',
      from: 'workExperienceDetails',
    });
    this.qualificationsForm = this.fb.group({
      type: ['', Validators.required],
      title: [''],
      institution: [''],
      file: [''],
      from: 'qualificationDetails',
      idx: 'Qualification-New',
    });
    this.additionalDocumentsForm = this.fb.group({
      description: [''],
      name: [''],
      file: ['', Validators.required],
      from: 'additiondocDetails',
      idx: 'AdditionDoc-New',
    });
    this.referenceForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required]],
      phone: [''],
      position: [''],
      org: [''],
      from: 'referenceDetails',
      idx: 'Reference-New',
    });
    this.roleTypeForm = this.fb.group({
      type_id: [''],
      role_type: ['', Validators.required],
      stu_type: ['6'],
      university: [''],
      passed_year: [''],
      not_teacher_role: [''],
      from: ['consumerType'],
      tags: [[]],
      experiance_tree: [[], this.atLeastOneTeachingLevelValidator],
    });
    // Remove static validator assignment for tags; manage dynamically in onParentChange



    this.editAccreditationForm = this.fb.group({
      accreditation_name: ['', Validators.required],
      accreditation_id: ['', Validators.required],
      expiry_date: ['', Validators.required],
      idx: ['Accreditation-New'],
      from: ['accreditationDetails'],
    });
    this.QCTRegistrationForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      dob: ['', Validators.required],
      employee_number: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d{7}$/), // Only numbers, exactly 7 digits
        ],
      ],
      qct_number: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d{6}$/), // Only numbers, exactly 6 digits
        ],
      ],
      qld_confirmation: ['', Validators.requiredTrue],
      qld_verify_consent: ['', Validators.requiredTrue],
      from: ['QCTRegistration'],
    });
  }

  createAccreditationGroup(): FormGroup {
    return this.fb.group({
      accreditation_name: ['', Validators.required],
      accreditation_id: ['', Validators.required],
      expiry_date: ['', Validators.required],
      index: [''],
      from: ['accreditationDetails'],
    });
  }
  // Custom validator for experiance_tree: must be a non-empty array if role_type is 1 (teacher)
  atLeastOneTeachingLevelValidator(control: AbstractControl) {
    if (!control.parent) return null;
    const roleType = control.parent.get('role_type')?.value;
    const value = control.value;
    if (roleType === 1) {
      if (Array.isArray(value) && value.length > 0) {
        return null;
      }
      return { required: true };
    }
    return null;
  }
  get accreditations(): FormArray {
    return this.editAccreditationForm.get('accreditations') as FormArray;
  }

  addAccreditation() {
    this.accreditations.push(this.createAccreditationGroup());
  }

  removeAccreditation(index: number) {
    this.accreditations.removeAt(index);
  }

  setValuesForForms() {
    console.log('Profile Data:', this.profileData);
    // Extract video intro details and set videoMeta for preview
    const videoIntroDetails = this.profileData?.meta?.video_intro_details;
    if (videoIntroDetails?.video_intro_link) {
      const ytId = this.getYouTubeId(videoIntroDetails.video_intro_link);
      if (ytId) {
        this.introVideo = {
          type: 'youtube',
          id: ytId,
          url: videoIntroDetails.video_intro_link,
          title: videoIntroDetails.video_intro_title || '',
          thumbnail: videoIntroDetails.video_intro_thumbnail || '',
          duration: videoIntroDetails.video_intro_duration || null,
        };
      } else {
        // Could add Vimeo support here if needed
        const vimeoId = this.getVimeoId(videoIntroDetails.video_intro_link);
        if (vimeoId) {
          this.introVideo = {
            type: 'vimeo',
            id: vimeoId,
            url: videoIntroDetails.video_intro_link,
            title: videoIntroDetails.video_intro_title || '',
            thumbnail: videoIntroDetails.video_intro_thumbnail || '',
            duration: videoIntroDetails.video_intro_duration || null,
          };
        } else {
          this.introVideo = null;
        }
      }
    } else {
      this.introVideo = null;
    }

    this.public_profile_show = this.profileData?.meta?.public_profile_show;
    this.bce_work_status = this.profileData?.bce_data?.bce_work_status || 'S'; //
    this.bceQuestionsForm.patchValue({
      card_type: this.profileData?.bce_data?.meta?.card_type || '',
      blue_card_type: this.profileData?.bce_data?.meta?.blue_card_type || '',
      prefered_location:
        this.profileData?.bce_data?.meta?.prefered_location || '',
      personal_email: this.profileData?.bce_data?.meta?.personal_email || '',
      right_to_work: this.profileData?.bce_data?.meta?.right_to_work || '',
      about_interest: this.profileData?.bce_data?.meta?.about_interest || '',
      bce_roles: this.profileData?.bce_data?.meta?.bce_roles || '',
      interested_role: this.profileData?.bce_data?.meta?.interested_role || [],
      // Safeguarding questions
      negative_notice: this.profileData?.bce_data?.meta?.negative_notice || '',
      suspended_registration:
        this.profileData?.bce_data?.meta?.suspended_registration || '',
      abused: this.profileData?.bce_data?.meta?.abused || '',
      accused: this.profileData?.bce_data?.meta?.accused || '',
      substantiated: this.profileData?.bce_data?.meta?.substantiated || '',
      criminal: this.profileData?.bce_data?.meta?.criminal || '',
      all_questions: this.profileData?.bce_data?.meta?.all_questions || '',
      // Multiple choice
      teachingLevels: this.profileData?.bce_data?.meta?.teachingLevels || [],
      subject: this.profileData?.bce_data?.meta?.subject || [],
    });

  }
  openEditProfileModal() {
    this.bsModalRef = this.modalService.show(this.editProfileModal, {
      class: 'modal-lg',
      backdrop: 'static',
      keyboard: false,
    });
    this.editPersonalInformationForm.patchValue({
      teacher_image: this.profileData?.profile_image || '',
      firstname: this.profileData?.user?.first_name || '',
      lastname: this.profileData?.user?.last_name || '',
      previous_lastname: this.profileData?.meta.previous_lastname || '',
      gender: this.profileData?.meta.gender || '',
      country: this.profileData?.address?.address_timezone.country || '',
      address_state: this.profileData?.address?.address_timezone.state || '',
      address_streetNumber: this.profileData?.address?.locality || '',
      address_streetName: this.profileData?.address?.street || '',
      address_city: this.profileData?.address?.city || '',
      address_postalcode: this.profileData?.address?.postal_code || '',
      mobilephonenumber: this.profileData?.phone || '',
      email: this.profileData?.user?.email || '',
      emergency_contact_name1:
        this.profileData?.meta?.emergency_contact?.emergency_contact_name1 ||
        '',
      emergency_contact_phone1:
        this.profileData?.meta?.emergency_contact?.emergency_contact_phone1 ||
        '',
      emergency_contact_name2:
        this.profileData?.meta?.emergency_contact?.emergency_contact_name2 ||
        '',
      emergency_contact_relation1:
        this.profileData?.meta?.emergency_contact?.emergency_contact_relation1 ||
        '',
      emergency_contact_relation2:
        this.profileData?.meta?.emergency_contact?.emergency_contact_relation2 ||
        '',
      emergency_contact_phone2:
        this.profileData?.meta?.emergency_contact?.emergency_contact_phone2 ||
        '',
      from: 'profileDetails',
    });
  }
  onWorkStartDateChange(date: any) {
    if (!date || date === undefined) {
      this.rightsToWorkForm.patchValue({ work_start_date: null });
      console.log(get(this.rightsToWorkForm.value, 'work_start_date'));
    } else {
      this.rightsToWorkForm.patchValue({ work_start_date: date });
    }
  }
  openEditStatusModal() {
    this.bsModalRef = this.modalService.show(this.editStatusModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
    this.editStatusForm.patchValue({
      from: 'teacherStatus',
      status: this.profileData?.meta.status || '',
    });
  }

  openEditAccreditationModal(accreditation: any, index?: number) {
    if (accreditation != null && accreditation != '') {
      this.editAccreditationForm.patchValue({
        accreditation_name: accreditation.accreditation_name || '',
        accreditation_id: accreditation.accreditation_id || '',
        expiry_date: this.formatExpiryDate(accreditation.expiry_date) || '',
        idx: `Accreditation-${index}`,
        from: 'accreditationDetails',
      });
    } else {
      this.editAccreditationForm.reset({
        accreditation_name: '',
        accreditation_id: '',
        expiry_date: '',
        idx: 'Accreditation-New',
        from: 'accreditationDetails',
      });
    }
    this.bsModalRef = this.modalService.show(this.editAccreditationModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }

  openRightsToWorkModal() {
    this.bsModalRef = this.modalService.show(this.rightsToWorkModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });

    this.rightsToWorkForm.patchValue({
      from: 'rightToWorkDetails',
      right_to_work: this.profileData?.meta.right_to_work || '',
      work_start_date:
        this.toNgbDateStruct(this.profileData?.meta.work_start_date || null),
    });

  }
  // Utility to convert DD/MM/YYYY string to NgbDateStruct
  private toNgbDateStruct(dateStr: string): NgbDateStruct | null {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split('/').map(Number);
    if (!day || !month || !year) return null;
    return { year, month, day };
  }

  isTeacherRole: boolean = false;
  openSkillsModal() {
    if (this.profileData?.consumer_type?.parent_type_id === undefined) {
      this.openRoleTypeModal();
      this.toastr.warning('Please select your Role Type first to set your skills and experience.');
      return;
    }
    this.skillsForm.patchValue({
      tags: this.profileData?.meta.tags || [],
      experiance_tree: this.profileData?.meta.experiance_tree || [],
      experience_description:
        this.profileData?.meta?.experience_description || '',
      video_cv: this.profileData?.work_experience?.video_cv || '',
    });
    // Subject (tags) validator is now managed only by onParentChange
    // Set a flag for template error display
    this.isTeacherRole = this.profileData?.consumer_type?.parent_type_id === 1;
    this.bsModalRef = this.modalService.show(this.skillsModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }
  openWorkExperienceModal(work_experience: any) {
    // Only patch values if index exists and is not empty
    console.log(work_experience);
    if (work_experience != null && work_experience != '') {
      this.workExperienceForm.patchValue({
        job_title: work_experience.job_title || '',
        school_name: work_experience.school_name || '',
        from_date: this.formatExpiryDate(work_experience.from_date) || '',
        to_date: this.formatExpiryDate(work_experience.to_date) || '',
        experience_summary: work_experience.experience_summary || '',
        idx: 'workexperience-' + work_experience.idx,
        from: 'workExperienceDetails',
      });
    } else {
      // Reset the form for a fresh entry
      this.workExperienceForm.reset({
        job_title: '',
        school_name: '',
        from_date: '',
        to_date: '',
        experience_summary: '',
        idx: 'workexperience-New',
        from: 'workExperienceDetails',
      });
    }
    this.bsModalRef = this.modalService.show(this.workExperienceModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }
  openQualificationsModal(qualification?: any) {
    if (qualification != null && qualification != '') {
      this.qualificationsForm.patchValue({
        type: qualification.type || '',
        title: qualification.title || '',
        institution: qualification.institution || '',
        file: '', // File cannot be set directly, leave empty
        idx: 'Qualification-' + qualification.idx,
        from: 'qualificationDetails',
      });
      this.fileName = false; // Reset file name display
    } else {
      // New entry
      this.qualificationsForm.reset({
        type: '',
        title: '',
        institution: '',
        file: '',
        idx: 'Qualification-New',
        from: 'qualificationDetails',
      });
      this.fileName = false;
    }
    this.bsModalRef = this.modalService.show(this.qualificationsModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }
  openAdditionalDocumentsModal(document?: any) {
    console.log(document);
    if (document != null && document != '') {
      // Extract file name from URL if present
      this.existingFileName = document.file ? document.file.split('/').pop()?.split('?')[0] : '';
      // Remove Validators.required if file exists
      const fileControl = this.additionalDocumentsForm.get('file');
      if (this.existingFileName && fileControl) {
        fileControl.clearValidators();
        fileControl.updateValueAndValidity();
      }
      this.additionalDocumentsForm.patchValue({
        name: document.name || '',
        description: document.description || '',
        file: '', // File cannot be set directly, leave empty
        from: 'additiondocDetails',
        idx: 'AdditionDoc-' + document.idx,
      });
      this.addFileName = false; // Reset file name display
    } else {
      // New entry
      this.existingFileName = '';
      const fileControl = this.additionalDocumentsForm.get('file');
      if (fileControl) {
        fileControl.setValidators([Validators.required]);
        fileControl.updateValueAndValidity();
      }
      this.additionalDocumentsForm.reset({
        name: '',
        description: '',
        file: '',
        idx: 'AdditionDoc-New',
        from: 'additiondocDetails',
      });
      this.addFileName = false;
    }
    this.bsModalRef = this.modalService.show(this.additionalDocumentsModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }
  openReferencesModal(reference?: any) {
    console.log(reference);
    if (reference != null && reference != '') {
      this.referenceForm.patchValue({
        name: reference.name || '',
        email: reference.email || '',
        phone: reference.phone || '',
        position: reference.position || '',
        org: reference.org || '',
        idx: 'Reference-' + reference.idx,
        from: 'referenceDetails',
      });
    } else {
      // New entry
      this.referenceForm.reset({
        name: '',
        email: '',
        phone: '',
        position: '',
        org: '',
        idx: 'Reference-New',
        from: 'referenceDetails',
      });
    }
    this.bsModalRef = this.modalService.show(this.referenceModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }
  private getRoleTypeSubTypeValues(): { stu_type: string; not_teacher_role: string } {
    const parentTypeId = this.profileData?.consumer_type?.parent_type_id;
    const parentTag = this.consumer_type_parentTag?.find((item: any) => item.parent_id == parentTypeId);
    const tag = parentTag?.tag?.toLowerCase() || '';
    const subTypeId = this.profileData?.consumer_type?.sub_type_id?.toString() || '';
    const isNonTeacher = tag.includes('non-teacher');
    const isUniversity = !isNonTeacher && tag.includes('university');
    return {
      stu_type: isUniversity ? subTypeId : '',
      not_teacher_role: isNonTeacher ? subTypeId : '',
    };
  }
  openRoleTypeModal() {
    this.bsModalRef = this.modalService.show(this.roleTypeModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
    // Restore previous selections if available, else reset
    const experianceTree = this.profileData?.meta?.experiance_tree || [];
    const parentSet = new Set(this.parentLevels);
    this.selectedParents = experianceTree.filter((item: string) => parentSet.has(item));
    this.selectedChildren = experianceTree.filter((item: string) => !parentSet.has(item));
    // Update childLevels based on selected parents
    const allChildren = this.selectedParents
      .map(parent => this.new_teaching_level[parent] || [])
      .flat();
    this.childLevels = Array.from(new Set(allChildren));
    // Patch to form

    const subTypeValues = this.getRoleTypeSubTypeValues();
    this.roleTypeForm.patchValue({
      experiance_tree: experianceTree,
      tags: this.profileData?.meta?.tags || [],
      subject: this.profileData?.meta?.subject || [],
      role_type: this.profileData?.consumer_type?.parent_type_id?.toString() || '',
      stu_type: subTypeValues.stu_type,
      passed_year: this.profileData?.consumer_type?.passed_year || '',
      university: this.profileData?.consumer_type?.university || '',
      not_teacher_role: subTypeValues.not_teacher_role,
    });

    this.showMainRoleType = true;
  }
  onStatusInput() {
    const control = this.editStatusForm.get('status');
    if (control && control.value && control.value.length > 140) {
      control.setValue(control.value.substring(0, 140));
    }
  }
  onTabChange(tab: 'invites' | 'history') {
    this.activeTab = tab;
    if (tab === 'invites') {
      this.currentPage = 1;
      this.loadProfileAPI();
    }
  }

  parentLevels: string[] = [];
  childLevels: string[] = [];
  selectedParent: string = '';
  selectedChildren: string[] = [];

  loadProfileAPI(from?: boolean, mixpanelCall?: any) {
    this.ngxService.start();
    if (mixpanelCall == 'loadMixpanel') {
      this.mixpanelCall();
    }
    this.ProfileService.profilePageAPI().subscribe({
      next: (res: any) => {
        if (res.status) {
          console.log('Profile API response:', res);
          this.showQldSection = res.data?.show_qld_popup;
          // console.log('Profile API response1:', from);

          this.profileData = res.data.user_data || [];
          if (from) {
            setTimeout(() => {
              this.action = 'OPEN_Qld_PROFILE';
            }, 1000);
          }
          // Send updated profile image to shared service
          if (res.data.user_data?.meta?.profile_image) {
            this.sharedService.teacher_logo.next(res.data.user_data.meta.profile_image);
          }
          this.editPersonalInformationForm.patchValue({
            mobilephonenumber: this.profileData?.phone || '',
            email: this.profileData?.user?.email || '',
          });
          this.using_cc_to_B = this.profileData?.meta?.using_CC_to?.using_cc_to_B === '1';
          // Set bookings_on_off cookie based on using_cc_to_B
          if (typeof this.profileData?.meta?.using_CC_to?.using_cc_to_B !== 'undefined') {
            const bookingsValue = this.profileData?.meta?.using_CC_to?.using_cc_to_B ? '1' : '0'
            document.cookie = 'bookings_on_off=' + bookingsValue + '; path=/;';
            localStorage.setItem('bookings_on_off', bookingsValue);
          }
          this.showOnboarding = this.isOnboardingIncomplete;
          this.ProfileService.setStatus(this.using_cc_to_B);
          let firstname = this.profileData?.user?.first_name || '';
          let lastname = this.profileData?.user?.last_name || '';
          this.sharedService.teacher_name.next(firstname + ' ' + lastname);
          localStorage.setItem('full_name', firstname + ' ' + lastname);

          // Set showOnboarding based on onboarding completion
          this.triggerOnboardingFlow();

          this.profileInfo = res.data || [];
          // this.availability_health = res.data.availability_health;
          this.experiance_tree = res.data.teaching_levels_all || [];
          this.subjectFilter = res.data.subject_tags || [];
          this.qualification_choices = res.data.qualification_choices || [];
          this.all_bce_subjects = res.data.bce_choices?.all_bce_subjects || [];
          this.bce_subjects = res.data.bce_choices?.bce_subjects || [];
          this.expiry_year = res.data.bce_choices?.expiry_year || [];
          this.interested_role = res.data.bce_choices?.interested_role || [];
          this.location_preferences =
            res.data.bce_choices?.prefered_location || [];
          this.right_to_work = res.data.bce_choices?.right_to_work || [];
          this.roles_interested_in = res.data.bce_choices?.bce_roles || [];
          this.subject = res.data.bce_choices?.subject || [];
          this.teachingLevels = res.data.bce_choices?.teachingLevels || [];
          this.countries = res.data.country_states?.countries || [];
          this.countryStates = res.data.country_states || {};
          this.consumer_type_parentTag = res.data.consumer_type || {};
          // After fetching teacher_teaching_levels:
          this.parentLevels = Object.keys(res.data.teacher_teaching_levels || {});
          this.selectedParent = this.parentLevels[0] || '';
          this.new_teaching_level = res.data.teacher_teaching_levels || {};

          // Split experiance_tree into parents and children for dropdowns
          const experianceTree = res.data.user_data?.meta?.experiance_tree || [];
          const parentSet = new Set(this.parentLevels);
          this.selectedParents = experianceTree.filter((item: string) => parentSet.has(item));
          this.selectedChildren = experianceTree.filter((item: string) => !parentSet.has(item));

          // Update childLevels based on selected parents
          const allChildren = this.selectedParents
            .map((parent: string) => this.new_teaching_level[parent] || [])
            .flat();
          this.childLevels = Array.from(new Set(allChildren));
          this.roleTypeForm.patchValue({
            subject: res.data.user_data?.meta?.subject || [],
          });

          const planToWorkGroupValue = res.data.user_data?.custom_field?.Cairns?.plan_to_work_group;
          this.plan_to_work_group =
            planToWorkGroupValue === true ||
            planToWorkGroupValue === 1 ||
            planToWorkGroupValue === '1' ||
            planToWorkGroupValue === 'true';

          this.custom_fields_Cairns_0_CNS = res.data.user_data?.custom_field?.Cairns?.["CNS Payroll ID"] || '';
          this.custom_fields_Cairns_0_Previous = res.data.user_data?.custom_field?.Cairns?.["Previous Surname"] || '';
          this.custom_fields_Cairns_0_Alternative = res.data.user_data?.custom_field?.Cairns?.["Alternative Work Email Address"] || '';

          this.new_teaching_level = res.data.teacher_teaching_levels || [];
          // After you set this.consumer_type_childTag, add:
          // Filter child tags based on parent_id
          // Find student and non-teacher types by tag name instead of index, safely
          const consumerTypes = Array.isArray(res?.data?.consumer_type) ? res.data.consumer_type : [];
          const studentType = consumerTypes.find((t: any) => t.tag && typeof t.tag === 'string' && t.tag.toLowerCase().includes('university'));
          const nonTeacherType = consumerTypes.find((t: any) => t.tag && typeof t.tag === 'string' && t.tag.toLowerCase().includes('non-teacher'));
          this.consumer_typeStudent = Array.isArray(studentType?.sub_types) ? studentType.sub_types : [];
          this.consumer_typeNonTeacher = Array.isArray(nonTeacherType?.sub_types) ? nonTeacherType.sub_types : [];

          // Set Australia as default country if not already set
          if (!this.editPersonalInformationForm.value.country) {
            this.editPersonalInformationForm.patchValue({
              country: 'Australia',
            });
          }
          // Set availableStates to Australia states by default
          this.availableStates = this.countryStates['Australia'] || [];
          this.CountrySelectorAus = res.data.country_states['Australia'] || [];
          this.CountrySelectorNZ = res.data.country_states['New Zealand'] || [];
          this.CountrySelectorSingapore =
            res.data.country_states['Singapore'] || [];
          this.hideButton = true;
          this.setValuesForForms();
          this.ngxService.stop();
          let isQLDOnboarding = localStorage.getItem('QLDOnboardning');
          if (isQLDOnboarding == null) {
            this.checkQldProfileCompletion();
          }
          setTimeout(() => {
            if (localStorage.getItem('QLDOnboardning')) {
              localStorage.removeItem('QLDOnboardning');
            }
          }, 3000);
        } else {
          this.ngxService.stop();
          this.toastr.error(res.message || 'Failed to load profile');
        }
      },
      error: (err: any) => {
        this.toastr.error(err.message || 'Failed to load profile');
        this.ngxService.stop();
      },
    });
  }

  checkQldProfileCompletion() {
    const status = this.profileData?.qld_data?.status;
    const emergencyContact = this.profileData?.meta?.emergency_contact;

    if (status === 'A') {
      // Check if any required emergency contact fields are empty
      const fieldsToCheck = [
        emergencyContact?.emergency_contact_name1,
        emergencyContact?.emergency_contact_name2,
        emergencyContact?.emergency_contact_phone1,
        emergencyContact?.emergency_contact_phone2,
        emergencyContact?.emergency_contact_relation1,
        emergencyContact?.emergency_contact_relation2,
      ];

      const hasEmptyField = fieldsToCheck.some(
        (field) => !field || field.trim() === ''
      );

      if (hasEmptyField) {
        this.checkCountIncompleteOpen();
      }
    }
  }

  checkCountIncompleteOpen() {
    let count = Number(localStorage.getItem('QLDIncompletePopupCount')) || 0;
    if (count < 5) {
      this.bsModalRef?.hide(); // Close any existing modal before showing a new one  
      setTimeout(() => {
        this.bsModalRef = this.modalService.show(this.QLDProfileIncompleteModal);
      }, 1000);

      count++;
      localStorage.setItem('QLDIncompletePopupCount', count.toString());
    } else {
      console.log('Popup limit reached (5 times).');
    }
  }


  selectedParents: string[] = [];

  // Call this when parent selection changes
  onParentChange(selected: string[]) {
    this.selectedParents = selected;
    // Merge all children from selected parents, flatten, and deduplicate
    const allChildren = selected
      .map(parent => this.new_teaching_level[parent] || [])
      .flat();
    this.childLevels = Array.from(new Set(allChildren)); // string[]

    // Only keep selected children that are still available
    this.selectedChildren = this.selectedChildren.filter(child =>
      allChildren.includes(child)
    );

    // Subject (tags) field logic for skillsForm
    const tagsControlSkills = this.skillsForm.get('tags');
    if (tagsControlSkills) {
      if (selected.length === 1 && selected[0] === 'Early Childhood') {
        // Only Early Childhood selected: hide and clear validators
        tagsControlSkills.clearValidators();
        tagsControlSkills.updateValueAndValidity();
      } else if (selected.includes('Secondary')) {
        // Secondary selected (alone or with others): required
        tagsControlSkills.setValidators([Validators.required, Validators.maxLength(10)]);
        tagsControlSkills.updateValueAndValidity();
      } else if (selected.includes('Primary')) {
        // Primary only (or with others except Secondary): optional
        tagsControlSkills.clearValidators();
        tagsControlSkills.setValidators([Validators.maxLength(10)]);
        tagsControlSkills.updateValueAndValidity();
      } else {
        tagsControlSkills.clearValidators();
        tagsControlSkills.updateValueAndValidity();
      }
    }

    // Subject (tags) field logic for roleTypeForm
    const tagsControlRoleType = this.roleTypeForm.get('tags');
    if (tagsControlRoleType) {
      if (selected.length === 1 && selected[0] === 'Early Childhood') {
        // Only Early Childhood selected: hide and clear validators
        tagsControlRoleType.clearValidators();
        tagsControlRoleType.updateValueAndValidity();
      } else if (selected.includes('Secondary')) {
        // Secondary selected (alone or with others): required
        tagsControlRoleType.setValidators([Validators.required, Validators.maxLength(10)]);
        tagsControlRoleType.updateValueAndValidity();
      } else if (selected.includes('Primary')) {
        // Primary only (or with others except Secondary): optional
        tagsControlRoleType.clearValidators();
        tagsControlRoleType.setValidators([Validators.maxLength(10)]);
        tagsControlRoleType.updateValueAndValidity();
      } else {
        tagsControlRoleType.clearValidators();
        tagsControlRoleType.updateValueAndValidity();
      }
    }
  }
  getFilterInputs() {
    if (this.activeTab === 'invites') {
      this.currentPage = 1;
      this.loadProfileAPI();
    }
  }
  onCountryChange() {
    const selectedCountry = this.editPersonalInformationForm.value.country;
    // Get states for selected country from countryStates
    const states = this.countryStates[selectedCountry] || [];
    // Set the state dropdown options (you may need to bind this to your template)
    this.availableStates = states;
    // Optionally reset the selected state if country changes
    this.editPersonalInformationForm.patchValue({ address_state: '' });
  }
  selectAll(type: any, event: any) {
    const checked = event.target.checked;
    if (type === 'All') {
      this.schoolDetails = [];
      this.profileData.forEach((x: any) => {
        x.isChecked = checked;
        if (checked) {
          this.schoolDetails.push(x);
        }
      });
      this.hideButton = !checked;
    } else {
      type.isChecked = checked;
      if (checked) {
        this.schoolDetails.push(type);
      } else {
        this.schoolDetails = this.schoolDetails.filter((x) => x !== type);
      }
      this.hideButton = this.schoolDetails.length === 0;
    }
    this.selectAllCheck =
      this.profileData.length === this.schoolDetails.length &&
      this.profileData.length > 0;
  }

  accepetRequestModal(action: 'accept' | 'decline') {
    this.actionType = action;
    this.bsModalRef = this.modalService.show(this.acceptRequestModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }

  actionModal(school: any, action: 'accept' | 'decline') {
    this.school = school;
    this.schoolName = school.school.title;
    this.actionType = action;
    this.bsModalRef = this.modalService.show(this.actionModals, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }

  getFormControlValues() {
    if (this.actionType == 'accept') {
      this.actionForm.patchValue({
        action: 'accept',
      });
      return this.actionForm.value;
    } else if (this.actionType == 'decline') {
      this.actionForm.patchValue({
        action: 'decline',
      });
      return this.actionForm.value;
    } else {
      return this.declineInviteForm.value;
    }
  }

  checkLength() {
    const timing = this.actionForm.controls['decline_reason'].value || '';
    this.ShowLenght = this.ShowLenghtError - timing.length;
  }

  findNewSchool(): void {
    this.router.navigate(['teacher/find-new-school']);
  }
  goToCalendar() {
    this.router.navigate(['teacher/calendar']);
  }

  bce_work_status: string = 'S'; // default value

  onPlanningToWorkChange(value: string) {
    this.bce_work_status = value;
    if (value === 'Y') {
      this.bsModalRef = this.modalService.show(this.bceQuestionsModal, {
        class: 'modal-lg',
        backdrop: 'static',
      });
    }
  }

  // Helper function for "DD MMM YYYY" format
  formatDateToDDMMMYYYY(dateStr: string): string {
    if (!dateStr) return '';
    // If already in "DD MMM YYYY" format, return as is
    if (/^\d{2} [A-Za-z]{3} \d{4}$/.test(dateStr)) return dateStr;
    // Otherwise, format using moment
    return moment(dateStr, [
      'DD/MM/YYYY',
      'YYYY-MM-DD',
      'MM/DD/YYYY',
      'DD MMM YYYY',
    ]).format('DD MMM YYYY');
  }

  sendFormValue(from: any): any {
    if (from === 'profileDetails') {
      const formValue = {
        ...this.editPersonalInformationForm.value,
        teacher_image:
          this.croppedImage ||
          this.editPersonalInformationForm.value.teacher_image,
      };
      return formValue;
    } else if (from === 'accreditation') {
      const formValue = { ...this.editAccreditationForm.value };
      formValue.expiry_date = this.formatDateToDDMMMYYYY(formValue.expiry_date);
      // Do not override idx if already set
      // if (!formValue.idx || formValue.idx === '') {
      //   formValue.idx = 'Accreditation-New';
      // }
      return formValue;
    } else if (from === 'teacherStatus') {
      const formValue = {
        ...this.editStatusForm.value,
      };
      return formValue;
    } else if (from === 'skills') {
      let experiance_tree = this.skillsForm.value.experiance_tree || [];
      // If teacher role, combine selectedParents and selectedChildren
      if (this.profileData?.consumer_type?.parent_type_id === 1) {
        experiance_tree = Array.from(new Set([...(this.selectedParents || []), ...(this.selectedChildren || [])]));
      }
      const formValue = {
        ...this.skillsForm.value,
        tags: this.skillsForm.value.tags || [],
        experiance_tree,
      };
      return formValue;
    } else if (from === 'workExperience') {
      const fromDate = this.workExperienceForm.value.from_date;
      const toDate = this.workExperienceForm.value.to_date;
      const formValue = {
        ...this.workExperienceForm.value,
        from_date: this.formatDateToDDMMMYYYY(fromDate),
        to_date: this.formatDateToDDMMMYYYY(toDate),
      };
      return formValue;
    } else if (from === 'qualifications') {
      const formValue = { ...this.qualificationsForm.value };
      // Defensive: if type is an array (shouldn't be), use first value
      let typeValue = Array.isArray(formValue.type) ? formValue.type[0] : formValue.type;
      if (formValue.file) {
        const formData = new FormData();
        formData.append('type', typeValue || '');
        formData.append('title', formValue.title || '');
        formData.append('institution', formValue.institution || '');
        formData.append('file', formValue.file, this.fileName || this.selectedFile?.name || 'document');
        let idxValue = formValue.idx && formValue.idx.startsWith('Qualification-') && formValue.idx !== 'Qualification-New'
          ? formValue.idx
          : 'Qualification-New';
        formData.append('idx', idxValue);
        formData.append('from', 'qualificationDetails');
        return formData;
      }
      return { ...formValue, type: typeValue };
    } else if (from === 'additionalDocuments') {
      const formValue = { ...this.additionalDocumentsForm.value };
      if (formValue.file) {
        const formData = new FormData();
        formData.append('name', formValue.name || '');
        formData.append('description', formValue.description || '');
        formData.append('file', formValue.file, this.addFileName || 'document.pdf');
        // If editing (idx starts with 'AdditionDoc-') and not 'AdditionDoc-New', keep the idx
        let idxValue = formValue.idx && formValue.idx.startsWith('AdditionDoc-') && formValue.idx !== 'AdditionDoc-New'
          ? formValue.idx
          : 'AdditionDoc-New';
        formData.append('idx', idxValue);
        formData.append('from', 'additiondocDetails');
        return formData;
      }
      return formValue;
    } else if (from === 'reference') {
      const formValue = { ...this.referenceForm.value };
      // If editing (idx starts with 'Reference-') and not 'Reference-New', keep the idx
      if (formValue.file) {
        const formData = new FormData();
        formData.append('name', formValue.name || '');
        formData.append('email', formValue.email || '');
        formData.append('phone', formValue.phone || '');
        formData.append('position', formValue.position || '');
        formData.append('org', formValue.org || '');
        let idxValue = formValue.idx && formValue.idx.startsWith('Reference-') && formValue.idx !== 'Reference-New'
          ? formValue.idx
          : 'Reference-New';
        formData.append('idx', idxValue);
        formData.append('from', 'referenceDetails');
        return formData;
      }
      return formValue;
    } else if (from === 'roleType') {
      const roleType = this.roleTypeForm.value.role_type.toString();
      const stuType = this.roleTypeForm.value.stu_type;
      const passed_year = this.roleTypeForm.value.passed_year;
      const university = this.roleTypeForm.value.university;
      const not_teacher_role = this.roleTypeForm.value.not_teacher_role;
      console.log('Selected role_type:', roleType);
      console.log('Selected not_teacher_role:', not_teacher_role);
      // Find the selected parent type object
      const parentTag = this.consumer_type_parentTag.find((item: any) => item.parent_id == roleType);
      if (parentTag) {
        console.log('Selected parent tag:', parentTag);
        const tag = parentTag.tag?.toLowerCase() || '';
        if (tag.includes('non-teacher')) {
          console.log('Selected not_teacher_role does not match any known tag. Defaulting to type_id:', not_teacher_role);
          this.roleTypeForm.patchValue({
            type_id: [parentTag.parent_id, not_teacher_role],
          });
        } else if (tag.includes('teacher')) {
          this.roleTypeForm.patchValue({ type_id: [parentTag.parent_id] });
        } else if (tag.includes('university')) {
          this.roleTypeForm.patchValue({
            type_id: [parentTag.parent_id, stuType],
            passed_year: passed_year,
            university: university,
          });
        } else {
          console.log('I', not_teacher_role);

          this.roleTypeForm.patchValue({ type_id: [parentTag.parent_id] });
        }
      } else {
        console.log('Selected role_type does not match any parent tag. Defaulting to type_id:', roleType);
        this.roleTypeForm.patchValue({ type_id: [roleType] });
      }
      this.roleTypeForm.patchValue({ from: 'consumerType' });

      // Combine selectedParents and selectedChildren, deduplicate, and patch to experiance_tree
      const combined = Array.from(new Set([...this.selectedParents, ...this.selectedChildren]));
      if (this.roleTypeForm && this.roleTypeForm.get('experiance_tree')) {
        this.roleTypeForm.patchValue({ experiance_tree: combined });
      }
      const formValue = {
        ...this.roleTypeForm.value,
      };
      return formValue;
    } else if (from === 'rightsToWork') {
      const dateValue = this.rightsToWorkForm.value.work_start_date;
      let formattedDate = '';
      if (dateValue && typeof dateValue === 'object' && 'year' in dateValue && 'month' in dateValue && 'day' in dateValue) {
        // NgbDateStruct: { year, month, day }
        const day = dateValue.day.toString().padStart(2, '0');
        const month = dateValue.month.toString().padStart(2, '0');
        const year = dateValue.year;
        formattedDate = `${day}/${month}/${year}`;
      } else if (typeof dateValue === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateValue)) {
        formattedDate = dateValue;
      } else {
        formattedDate = '';
      }
      const formValue = {
        ...this.rightsToWorkForm.value,
        work_start_date: formattedDate,
      };
      return formValue;
    } else if (from === 'bceQuestions') {
      const formValue = { ...this.bceQuestionsForm.value };
      // Format expiry_date only if not already DD/MM/YYYY
      if (
        formValue.expiry_date &&
        !/^\d{2}\/\d{2}\/\d{4}$/.test(formValue.expiry_date)
      ) {
        formValue.expiry_date = this.formatDateToDDMMYYYY(
          formValue.expiry_date
        );
      }
      // Only send QCT or Blue Card number based on card_type
      if (formValue.card_type === 'QCT') {
        // Combine QCT digits into a single string
        const qctNumber = Array.from({ length: 6 }, (_, i) => (formValue as any)[`qct_[${i}]`] || '').join('');
        (formValue as any).qct_number = qctNumber;
        // Set blueCard fields to empty string
        for (let i = 0; i < 8; i++) (formValue as any)[`blueCard_[${i}]`] = '';
      } else if (formValue.card_type === 'blueCard') {
        // Combine Blue Card digits into a single string
        const blueCardNumber = Array.from({ length: 8 }, (_, i) => (formValue as any)[`blueCard_[${i}]`] || '').join('');
        (formValue as any).blue_card_number = blueCardNumber;
        // Set qct_ fields to empty string
        for (let i = 0; i < 6; i++) (formValue as any)[`qct_[${i}]`] = '';
      }
      // If file is a Blob/File, send as FormData
      if (
        formValue.file &&
        typeof formValue.file === 'object' &&
        'size' in formValue.file &&
        'type' in formValue.file
      ) {
        const formData = new FormData();
        Object.keys(formValue).forEach((key) => {
          const value = (formValue as { [key: string]: any })[key];
          if (key === 'file') return;
          if (Array.isArray(value)) {
            formData.append(key, JSON.stringify(value));
          } else {
            formData.append(key, value);
          }
        });
        formData.append(
          'file',
          formValue.file,
          this.bceFileName || 'document.pdf'
        );
        return formData;
      }
      // If file is not a Blob/File, send the link (default patched value)
      return {
        ...formValue,
        file: '',
      };
    }
  }

  private formatExpiryDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      // Try to parse manually if Date fails
      const parts = dateStr.split(' ');
      if (parts.length === 3) {
        const day = parts[0];
        const month =
          [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ].indexOf(parts[1]) + 1;
        const year = parts[2];
        if (month > 0) {
          return `${day.padStart(2, '0')}/${month
            .toString()
            .padStart(2, '0')}/${year}`;
        }
      }
      return '';
    }
    const dd = date.getDate().toString().padStart(2, '0');
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  formatDateToDDMMYYYY(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '';
    const dd = date.getDate().toString().padStart(2, '0');
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  onBookingsChange(event: any) {
    // const checked = (event.target as HTMLInputElement).checked;
    const payload = {
      using_cc_to_B: event.target.checked ? 1 : 0,
      from: 'usingCCToDetails',
    };
    this.ngxService.start();
    this.ProfileService.saveProfileAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message || 'Profile updated successfully');
          window.location.replace(`${window.location.origin}/login?refresh=true&from=profileBookings`);
          // if (window.location.hostname === 'booking-test.classcover.com.au' && !event.target.checked) {
          //   window.location.replace("https://jobs-test.classcover.com.au/login?refresh=true&from=profileBookings");
          // } else if (window.location.hostname === 'booking.classcover.com.au' && !event.target.checked) {
          //   window.location.replace("https://jobs.classcover.com.au/login?refresh=true&from=profileBookings");
          // } else if (window.location.hostname === 'jobs-test.classcover.com.au' && event.target.checked) {
          //   window.location.replace("https://booking-test.classcover.com.au/login?refresh=true&from=profileBookings");
          // } else if (window.location.hostname === 'jobs.classcover.com.au' && event.target.checked) {
          //   window.location.replace("https://booking.classcover.com.au/login?refresh=true&from=profileBookings");
          // } else {
          //   window.location.replace("http://localhost:4200/login?refresh=true&from=profileBookings");
          // }
        } else {
          this.ngxService.stop();
          this.toastr.error(res.message || 'Failed to update profile');
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.message || 'Failed to update profile');
      },
    });
  }
  onPublicProfileShowChange(value: any) {
    const payload = {
      public_profile_show: value.target.checked ? '1' : '0',
      from: 'showPublicprofile',
    };
    this.ngxService.start();
    this.ProfileService.saveProfileAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message || 'Profile updated successfully');
          this.loadProfileAPI();
        } else {
          this.ngxService.stop();
          this.toastr.error(res.message || 'Failed to update profile');
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.message || 'Failed to update profile');
      },
    });
  }
  saveProfile(from: any) {
    // Check all required fields in the form being submitted
    let form: FormGroup;
    if (from === 'profileDetails') {
      form = this.editPersonalInformationForm;
    } else if (from === 'accreditation') {
      form = this.editAccreditationForm;
    } else if (from === 'teacherStatus') {
      form = this.editStatusForm;
    } else if (from === 'skills') {
      // Ensure validators are up-to-date before validation
      this.onParentChange(this.selectedParents);
      form = this.skillsForm;
    } else if (from === 'workExperience') {
      form = this.workExperienceForm;
    } else if (from === 'qualifications') {
      form = this.qualificationsForm;
    } else if (from === 'additionalDocuments') {
      form = this.additionalDocumentsForm;
    } else if (from === 'reference') {
      form = this.referenceForm;
    } else if (from === 'roleType') {
      // Ensure validators are up-to-date before validation
      this.onParentChange(this.selectedParents);
      form = this.roleTypeForm;
    } else if (from === 'rightsToWork') {
      form = this.rightsToWorkForm;
    } else if (from === 'roleType') {
      form = this.roleTypeForm;
      // experiance_tree
    } else {
      form = this.editPersonalInformationForm;
    }

    if (from === 'roleType') {
      const roleType = this.roleTypeForm.get('role_type')?.value;
      // Find the selected parent type object
      const parentTag = this.consumer_type_parentTag.find((item: any) => item.parent_id == roleType);
      console.log('Selected parent tag:', parentTag);
      if (parentTag) {
        console.log('Parent tag for validation:', parentTag.tag?.trim().toLowerCase());
        // Teacher: must have at least one selected child
        if (parentTag.tag?.trim().toLowerCase() === 'teacher' && this.selectedChildren.length === 0) {
          this.toastr.error('Please select at least one year/level.');
          // Try to scroll to the year/level field for better UX
          setTimeout(() => {
            const el = document.querySelector('[id="teaching-level-detail-label"]');
            if (el) {
              (el as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 100);
          return;
        }
        // University Student: must have university and passed_year
        if (parentTag.tag?.toLowerCase().includes('university') && (this.roleTypeForm.get('university')?.value === '' || this.roleTypeForm.get('passed_year')?.value === '')) {
          this.toastr.error('Please fill all mandatory fields.');
          return;
        }
        // Non-teacher: must have not_teacher_role
        if (parentTag.tag?.toLowerCase().includes('non-teacher') && (this.roleTypeForm.get('not_teacher_role')?.value === '')) {
          this.toastr.error('Please fill all mandatory fields.');
          return;
        }
      }
    }
    // // If form is invalid, show error and stop
    // if (form.invalid) {
    //   this.toastr.error('Please fill all mandatory fields.');
    //   return;
    // }
    if (form.invalid) {
      const missingFields: string[] = [];
      const messages: string[] = [];
      Object.keys(form.controls).forEach(key => {
        const control = form.get(key);
        if (control && control.invalid) {
          console.log(
            `Invalid control: ${key}`,
            {
              value: control.value,
              errors: control.errors,
              touched: control.touched,
              dirty: control.dirty
            }
          );
          if (control.errors?.['required']) {
            missingFields.push(this.getControlLabel(key));
          } else {
            messages.push(this.getControlErrorMessage(key, control));
          }
        }
      });
      form.markAllAsTouched();
      if (missingFields.length) {
        messages.unshift(`Please fill all mandatory fields: ${missingFields.join(', ')}`);
      }
      this.toastr.error(messages.join('<br>'), '', { enableHtml: true });
      return;
    }
    console.log('Form is valid, proceeding to save profile.' + this.editAccreditationForm.controls['idx'].value);
    if (from === 'accreditation') {
      // Mark all controls as touched to show validation errors
      Object.values(this.editAccreditationForm.controls).forEach((control) => {
        control.markAsTouched();
        control.updateValueAndValidity();
      });

      // If form is invalid, show error and stop
      if (this.editAccreditationForm.invalid) {
        this.toastr.error('Please fill all mandatory accreditation fields.');
        return;
      }
    }
    this.ngxService.start();
    this.ProfileService.saveProfileAPI(this.sendFormValue(from)).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.showMainRoleType = true;
          this.showNonTeacherType = false;
          this.showUniStudentType = false;
          this.iAmTeaching = false;
          this.bsModalRef.hide();
          this.toastr.success(res.message || 'Profile updated successfully');
          if (this.bsModalRef) {
            this.bsModalRef.hide();
          }
          setTimeout(() => {
            // Ensure modal is closed before opening the next
            this.loadProfileAPI();
          }, 1000); // Slightly longer delay to ensure modal is closed
        } else {
          this.ngxService.stop();
          this.toastr.error(res.message || 'Failed to update profile');
        }
      },
      error: (err: any) => {
        this.toastr.error(err.message || 'Failed to update profile');
        this.ngxService.stop();
      },
    });
  }
  private controlLabels: { [key: string]: string } = {
    tags: 'Subjects',
    experiance_tree: 'Teaching levels',
    experience_description: 'Short bio',
    video_cv: 'Video introduction',
    job_title: 'Job title',
    school_name: 'Company/School',
    from_date: 'Start date',
    to_date: 'End date',
    experience_summary: 'About your work experience',
    accreditation_name: 'Accreditation name',
    accreditation_id: 'Accreditation ID',
    expiry_date: 'Expiry date',
    right_to_work: 'Right to work',
    role_type: 'Role type',
    status: 'Status',
    type: 'Type',
    file: 'File',
  };

  private getControlLabel(key: string): string {
    return this.controlLabels[key] || key.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase());
  }

  // Builds a specific message for a non-required validation error, e.g. "Subjects: limit is 10, you have 13"
  private getControlErrorMessage(key: string, control: AbstractControl): string {
    const label = this.getControlLabel(key);
    const errors = control.errors || {};
    const isList = Array.isArray(control.value);
    if (errors['maxlength']) {
      const { requiredLength, actualLength } = errors['maxlength'];
      return isList
        ? `${label}: limit is ${requiredLength}, you have selected ${actualLength}. Please remove ${actualLength - requiredLength}.`
        : `${label}: limit is ${requiredLength} characters, you have entered ${actualLength}.`;
    }
    if (errors['minlength']) {
      return `${label}: minimum ${errors['minlength'].requiredLength} required`;
    }
    if (errors['email']) {
      return `${label}: please enter a valid email address`;
    }
    if (errors['pattern']) {
      return `${label}: invalid format`;
    }
    if (errors['bsDate']) {
      return `${label}: please select a valid date`;
    }
    return `${label}: invalid value (${Object.keys(errors).join(', ')})`;
  }

  imageChangedEvent: any = '';
  croppedImage: any = '';
  school_logo: any = '';
  containWithinAspectRatio = false;
  overview: any;
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    // this.school_logo = event.base64;
  }

  showCropper = false;
  imageLoaded() {
    this.showCropper = true;
    // show cropper
  }
  cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
    // cropper ready
  }
  loadImageFailed() {
    this.toastr.warning('Upload PNG format images');

    this.croppedImage = '';
    return;
    // show message
  }
  get f(): { [key: string]: AbstractControl } {
    return this.editPersonalInformationForm.controls;
  }
  closeAccreditationModal() {
    this.editAccreditationForm.reset({
      accreditation_name: '',
      accreditation_id: '',
      expiry_date: '',
      idx: 'Accreditation-New',
      from: 'accreditationDetails',
    });
    this.bsModalRef.hide();
  }
  closeModal() {
    this.bsModalRef.hide();
  }
  onFileSelected(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.fileName = !this.fileName;
      this.fileName = escape(input.files[0].name);
      // if (this.selectedFile.type !== 'application/pdf') {
      //   alert('Only PDF files are allowed!');
      //   this.selectedFile = null;
      //   return;
      // }

      const reader = new FileReader();
      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;

        // Convert binary data to Blob, preserving the uploaded file's actual type
        const blob = new Blob([arrayBuffer], { type: this.selectedFile?.type || 'application/octet-stream' });

        // ✅ Store binary (Blob) in FormControlcon
        // console.log(blob)
        this.qualificationsForm.patchValue({ file: blob });
      };
      reader.readAsArrayBuffer(this.selectedFile);
    }
  }
  removeFile(event: any) {
    event.preventDefault();
    const formData = new FormData();
    const fileBlob = this.qualificationsForm.value.file;
    if (fileBlob) {
      formData.delete(fileBlob);
    }
    this.qualificationsForm.patchValue({
      file: '',
    });
    this.fileName = false;
    return;
  }

  onFileSelectedAdditional(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedAdditionalFile = input.files[0];
      this.addFileName = !this.addFileName;
      this.addFileName = escape(input.files[0].name);
      // if (this.selectedFile.type !== 'application/pdf') {
      //   alert('Only PDF files are allowed!');
      //   this.selectedFile = null;
      //   return;
      // }

      const reader = new FileReader();
      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;

        // Convert binary data to Blob, preserving the uploaded file's actual type
        const blob = new Blob([arrayBuffer], { type: this.selectedAdditionalFile?.type || 'application/octet-stream' });

        // ✅ Store binary (Blob) in FormControlcon
        // console.log(blob)
        this.additionalDocumentsForm.patchValue({ file: blob });
      };
      reader.readAsArrayBuffer(this.selectedAdditionalFile);
    }
  }
  removeAdditionalFile(event: any) {
    event.preventDefault();
    const formData = new FormData();
    const fileBlob = this.additionalDocumentsForm.value.filw;
    if (fileBlob) {
      formData.delete(fileBlob);
    }
    this.additionalDocumentsForm.patchValue({
      file: '',
    });
    this.addFileName = false;
    return;
  }
  onRoleTypeChange(selected: string, id: any) {
    this.roleTypeForm.patchValue({
      role_type: id.toString(),
    });
    if (selected === 'Teacher') {
      this.showMainRoleType = false;
      this.showNonTeacherType = false;
      this.showUniStudentType = false;
      this.iAmTeaching = true;
    } else if (selected === 'University Student') {
      this.showUniStudentType = true;
      this.showMainRoleType = false;
      this.showNonTeacherType = false;
      this.iAmTeaching = false;
    } else if (selected === 'Non-teacher') {
      this.showNonTeacherType = true;
      this.showUniStudentType = false;
      this.showMainRoleType = false;
      this.iAmTeaching = false;
    }
  }
  onRoleTypeBack() {
    this.showMainRoleType = true;
    this.showNonTeacherType = false;
    this.showUniStudentType = false;
    this.iAmTeaching = false;
    // Restore previous selections if available, else reset
    const experianceTree = this.profileData?.meta?.experiance_tree || [];
    const parentSet = new Set(this.parentLevels);
    this.selectedParents = experianceTree.filter((item: string) => parentSet.has(item));
    this.selectedChildren = experianceTree.filter((item: string) => !parentSet.has(item));
    // Update childLevels based on selected parents
    const allChildren = this.selectedParents
      .map(parent => this.new_teaching_level[parent] || [])
      .flat();
    this.childLevels = Array.from(new Set(allChildren));
    // Patch to form
    const subTypeValues = this.getRoleTypeSubTypeValues();
    this.roleTypeForm.patchValue({
      experiance_tree: experianceTree,
      tags: this.profileData?.meta?.tags || [],
      subject: this.profileData?.meta?.subject || [],
      role_type: this.profileData?.consumer_type?.parent_type_id?.toString() || '',
      stu_type: subTypeValues.stu_type,
      passed_year: this.profileData?.consumer_type?.passed_year || '',
      university: this.profileData?.consumer_type?.university || '',
      not_teacher_role: subTypeValues.not_teacher_role,
    });
    // Mark controls as touched and update validity
    const expCtrl = this.roleTypeForm.get('experiance_tree');
    if (expCtrl) {
      expCtrl.markAsTouched();
      expCtrl.updateValueAndValidity();
      if (expCtrl.invalid) {
        console.log('Invalid experiance_tree:', expCtrl.errors);
      }
    }
    const tagsCtrl = this.roleTypeForm.get('tags');
    if (tagsCtrl) {
      tagsCtrl.markAsTouched();
      tagsCtrl.updateValueAndValidity();
      if (tagsCtrl.invalid) {
        console.log('Invalid tags:', tagsCtrl.errors);
      }
    }
    const subjectCtrl = this.roleTypeForm.get('subject');
    if (subjectCtrl) {
      subjectCtrl.markAsTouched();
      subjectCtrl.updateValueAndValidity();
      if (subjectCtrl.invalid) {
        console.log('Invalid subject:', subjectCtrl.errors);
      }
    }
  }
  closeRoleTypeModal() {
    this.showMainRoleType = true;
    this.iAmTeaching = false;
    this.showNonTeacherType = false;
    this.showUniStudentType = false;
    // Restore previous selections if available, else reset
    const experianceTree = this.profileData?.meta?.experiance_tree || [];
    const parentSet = new Set(this.parentLevels);
    this.selectedParents = experianceTree.filter((item: string) => parentSet.has(item));
    this.selectedChildren = experianceTree.filter((item: string) => !parentSet.has(item));
    // Update childLevels based on selected parents
    const allChildren = this.selectedParents
      .map(parent => this.new_teaching_level[parent] || [])
      .flat();
    this.childLevels = Array.from(new Set(allChildren));
    // Patch to form
    const subTypeValues = this.getRoleTypeSubTypeValues();
    this.roleTypeForm.patchValue({
      experiance_tree: experianceTree,
      tags: this.profileData?.meta?.tags || [],
      subject: this.profileData?.meta?.subject || [],
      role_type: this.profileData?.consumer_type?.parent_type_id?.toString() || '',
      stu_type: subTypeValues.stu_type,
      passed_year: this.profileData?.consumer_type?.passed_year || '',
      university: this.profileData?.consumer_type?.university || '',
      not_teacher_role: subTypeValues.not_teacher_role,
    });
    // Mark controls as touched and update validity
    const expCtrl = this.roleTypeForm.get('experiance_tree');
    if (expCtrl) {
      expCtrl.markAsTouched();
      expCtrl.updateValueAndValidity();
    }
    const tagsCtrl = this.roleTypeForm.get('tags');
    if (tagsCtrl) {
      tagsCtrl.markAsTouched();
      tagsCtrl.updateValueAndValidity();
    }
    const subjectCtrl = this.roleTypeForm.get('subject');
    if (subjectCtrl) {
      subjectCtrl.markAsTouched();
      subjectCtrl.updateValueAndValidity();
    }
    this.bsModalRef.hide();
  }
  step = 1;
  bceFileName = '';
  safeguardingQuestions = [
    'Have you been issued a negative notice (Blue card)?',
    'Have you ever had your QCT registration or Blue card suspended?',
    'Have you ever abused, exploited or neglected a child or vulnerable adult?',
    'Have you ever been accused of offences relating to a child or vulnerable adult?',
    'Have you ever been the subject of a substantiated complaint, or convicted of an offence relating to a child or vulnerable adult?',
    'Are you currently the subject of a criminal legal proceeding for an offence relating to a child or vulnerable adult?',
    'Are the responses you have provided to these questions true and correct?',
  ];

  subjectsList = [
    /* your subjects array */
  ];

  bceQuestionsForm = this.fb.group({
    'blueCard_[0]': ['', Validators.required],
    'blueCard_[1]': ['', Validators.required],
    'blueCard_[2]': ['', Validators.required],
    'blueCard_[3]': ['', Validators.required],
    'blueCard_[4]': ['', Validators.required],
    'blueCard_[5]': ['', Validators.required],
    'blueCard_[6]': ['', Validators.required],
    'blueCard_[7]': ['', Validators.required],
    'qct_[0]': ['', Validators.required],
    'qct_[1]': ['', Validators.required],
    'qct_[2]': ['', Validators.required],
    'qct_[3]': ['', Validators.required],
    'qct_[4]': ['', Validators.required],
    'qct_[5]': ['', Validators.required],
    bce_work_status: ['N', Validators.required], // default to 'no'
    card_type: ['', Validators.required],
    blue_card_type: ['', Validators.required],
    interested_role: [[], Validators.required],
    // Blue card fields
    card_holder_name: [''],
    // QCT fields
    prefered_location: ['', Validators.required],
    expiry_date: ['', Validators.required],
    personal_email: ['', [Validators.required, Validators.email]],
    right_to_work: ['', Validators.required],
    file: ['', Validators.required],
    about_interest: ['', Validators.required],
    bce_roles: ['', Validators.required],
    // Safeguarding questions
    negative_notice: ['', Validators.required],
    suspended_registration: ['', Validators.required],
    abused: ['', Validators.required],
    accused: ['', Validators.required],
    substantiated: ['', Validators.required],
    criminal: ['', Validators.required],
    all_questions: ['', Validators.required],
    // Multiple choice
    teachingLevels: [[], Validators.required],
    subject: [[], Validators.required],
    from: 'bceQuestions',
  });

  showBceFormError = false;
  missingFieldsError: string = '';
  goToStep(stepNum: number) {
    if (stepNum === 2) {
      let controls = [
        'bce_work_status',
        'card_type',
        ...(this.bceQuestionsForm.value.card_type === 'blueCard'
          ? [
            'blueCard_[0]',
            'blueCard_[1]',
            'blueCard_[2]',
            'blueCard_[3]',
            'blueCard_[4]',
            'blueCard_[5]',
            'blueCard_[6]',
            'blueCard_[7]',
            'card_holder_name',
            'expiry_date',
            'blue_card_type',
          ]
          : []),
        ...(this.bceQuestionsForm.value.card_type === 'QCT'
          ? ['qct_[0]', 'qct_[1]', 'qct_[2]', 'qct_[3]', 'qct_[4]', 'qct_[5]']
          : []),
        'prefered_location',
        'personal_email',
        'right_to_work',
        'file',
        'about_interest',
        'bce_roles',
        'interested_role',
      ];

      // Remove 'file' from required controls if bceFileName exists
      if (this.bceFileName) {
        controls = controls.filter((c) => c !== 'file');
      }

      let valid = true;
      let missingFields: string[] = [];
      controls.forEach((controlName) => {
        const control = this.bceQuestionsForm.get(controlName);
        control?.markAsTouched();
        control?.updateValueAndValidity();
        if (!control || control.invalid) {
          valid = false;
          // Map QCT and Blue Card fields to user-friendly names
          if (controlName.startsWith('qct_[')) {
            if (!missingFields.includes('QCT Number')) missingFields.push('QCT Number');
          } else if (controlName.startsWith('blueCard_[')) {
            if (!missingFields.includes('Blue Card Number')) missingFields.push('Blue Card Number');
          } else {
            missingFields.push(controlName);
          }
        }
      });

      if (!valid) {
        this.showBceFormError = true;
        this.missingFieldsError = `Please fill all mandatory fields: ${missingFields.join(', ')}`;
        this.toastr.error(this.missingFieldsError);
        return;
      }
      this.showBceFormError = false;
      this.missingFieldsError = '';
      this.step = stepNum;
    } else if (stepNum === 3) {
      // Step 2 validation (Safeguarding questions)
      const safeguardControls = [
        'negative_notice',
        'suspended_registration',
        'abused',
        'accused',
        'substantiated',
        'criminal',
        'all_questions',
      ];
      let valid = true;
      let missingFields: string[] = [];
      safeguardControls.forEach((controlName) => {
        const control = this.bceQuestionsForm.get(controlName);
        control?.markAsTouched();
        control?.updateValueAndValidity();
        if (!control || control.invalid) {
          valid = false;
          missingFields.push(controlName);
        }
      });
      if (!valid) {
        this.showBceFormError = true;
        this.missingFieldsError = `Please answer all safeguarding questions: ${missingFields.join(
          ', '
        )}`;
        this.toastr.error(this.missingFieldsError);
        return;
      }
      this.showBceFormError = false;
      this.missingFieldsError = '';
      this.step = stepNum;
    } else {
      this.step = stepNum;
    }
  }

  onBceFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.bceFileName = escape(file.name);
      this.bceQuestionsForm.patchValue({ file: file });
    }
  }

  removeBceFile(event: any) {
    this.bceFileName = '';
    this.bceQuestionsForm.patchValue({ file: '' });
  }
  submitBceQuestions() {
    if (this.bceQuestionsForm.value.bce_work_status === 'N') {
      var data = {
        bce_work_status: 'N',
        from: 'bceQuestions',
      };
      this.ngxService.start();
      this.ProfileService.saveBCEProfileAPI(data).subscribe({
        next: (res: any) => {
          if (res.status) {
            this.bsModalRef.hide();
            this.toastr.success(res.message || 'Profile updated successfully');
            this.loadProfileAPI();
          } else {
            this.ngxService.stop();
            this.toastr.error(res.message || 'Failed to update profile');
          }
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to update profile');
          this.ngxService.stop();
        },
      });
    }
    // Only validate if bce_work_status is 'yes' and on step 3
    if (
      this.bceQuestionsForm.value.bce_work_status === 'Y' &&
      this.step === 3
    ) {
      const controls = ['teachingLevels', 'subject'];
      let valid = true;
      let missingFields: string[] = [];
      controls.forEach((controlName) => {
        const control = this.bceQuestionsForm.get(controlName);
        control?.markAsTouched();
        control?.updateValueAndValidity();
        if (!control || control.invalid) {
          valid = false;
          missingFields.push(controlName);
        }
      });
      if (!valid) {
        this.showBceFormError = true;
        this.missingFieldsError = `Please fill all mandatory fields: ${missingFields.join(
          ', '
        )}`;
        this.toastr.error(this.missingFieldsError);
        return;
      } else {
        this.ngxService.start();
        this.ProfileService.saveBCEProfileAPI(
          this.sendFormValue('bceQuestions')
        ).subscribe({
          next: (res: any) => {
            if (res.status) {
              this.bsModalRef.hide();
              this.toastr.success(res.message || 'Profile loaded successfully');
              this.loadProfileAPI();
            } else {
              this.ngxService.stop();
              this.toastr.error(res.message || 'Failed to load profile');
            }
          },
          error: (err: any) => {
            this.toastr.error(err.message || 'Failed to load profile');
            this.ngxService.stop();
          },
        });
        // Submit the form (API call or further logic)
        // Example:
        // this.ProfileService.submitBceQuestions(this.bceQuestionsForm.value).subscribe(...);
      }
      this.showBceFormError = false;
      this.missingFieldsError = '';
    }
  }

  days = Array.from({ length: 31 }, (_, i) =>
    (i + 1).toString().padStart(2, '0')
  );
  months = Array.from({ length: 12 }, (_, i) =>
    (i + 1).toString().padStart(2, '0')
  );
  years = Array.from({ length: 50 }, (_, i) =>
    (new Date().getFullYear() - i).toString()
  );

  onCardTypeChange(type: string) {
    this.bceQuestionsForm.patchValue({ card_type: type });
  }
  blueCardBoxes = Array(7); // For 7 digits
  qctBoxes = Array(6); // For 6 digits

  onBlueCardDigitInput(event: any, index: number) {
    const input = event.target as HTMLInputElement;
    const maxLength = index === 7 ? 2 : 1;
    const value = (input.value || '').replace(/\D/g, '').slice(0, maxLength);

    // Ensure numeric-only value with the expected max length per segment.
    if (input.value !== value) {
      input.value = value;
      this.bceQuestionsForm.patchValue(
        { [`blueCard_[${index}]`]: value },
        { emitEvent: false }
      );
    }

    if (value && value.length === 1 && index < 7) {
      // Move to next box
      console.log('blueCard_' + '[' + (index + 1) + ']');

      const nextInput = document.getElementById(
        'blueCard_' + '[' + (index + 1) + ']'
      );
      if (nextInput) {
        (nextInput as HTMLInputElement).focus();
      }
    }
    // Optionally, handle backspace to move to previous box
    if (event.inputType === 'deleteContentBackward' && !value && index > 0) {
      const prevInput = document.getElementById(
        'blueCard_' + '[' + (index - 1) + ']'
      );
      if (prevInput) {
        (prevInput as HTMLInputElement).focus();
      }
    }
  }
  onQctDigitInput(event: any, index: number) {
    const input = event.target as HTMLInputElement;
    const value = (input.value || '').replace(/\D/g, '').slice(0, 1);

    // Keep OTP boxes strictly numeric, including when users paste text.
    if (input.value !== value) {
      input.value = value;
      this.bceQuestionsForm.patchValue(
        { [`qct_[${index}]`]: value },
        { emitEvent: false }
      );
    }

    if (value && value.length === 1 && index < 5) {
      // Move to next box
      const nextInput = document.getElementById(
        'qct_' + '[' + (index + 1) + ']'
      );
      if (nextInput) {
        (nextInput as HTMLInputElement).focus();
      }
    }
    // Optionally, handle backspace to move to previous box
    if (event.inputType === 'deleteContentBackward' && !value && index > 0) {
      const prevInput = document.getElementById(
        'qct_' + '[' + (index - 1) + ']'
      );
      if (prevInput) {
        (prevInput as HTMLInputElement).focus();
      }
    }
  }
  openBceModal(value: 'Y' | 'N' | '', from: '' | 'modal') {
    // Store original state before opening modal
    this.originalBceWorkStatus = this.bce_work_status;
    this.bce_work_status = value;
    if (from === 'modal') {
      return;
    } else {
      // Patch initial values from profileData if available
      this.bceFileName = this.profileData?.bce_data?.file_name;
      // set blue card and qct id fields
      if (this.profileData?.bce_data?.meta?.card_type === 'blueCard') {
        let blueCardId = this.profileData?.bce_data?.blue_card_id || '';
        // Remove any non-digit characters (like '/')
        blueCardId = blueCardId.replace(/\D/g, '');
        // First 7 boxes take one digit each; last box can take up to two digits.
        for (let i = 0; i < 7; i++) {
          this.bceQuestionsForm.patchValue({
            [`blueCard_[${i}]`]: blueCardId[i] || '',
          });
        }
        this.bceQuestionsForm.patchValue({
          'blueCard_[7]': blueCardId.slice(7, 9) || '',
          card_holder_name:
            this.profileData?.bce_data?.meta?.card_holder_name || '',
          expiry_date: this.profileData?.bce_data?.meta?.expiry_date || '',
        });
      } else {
        // Clear blue card fields if switching from blue card to QCT or no card
        for (let i = 0; i < 8; i++) {
          this.bceQuestionsForm.patchValue({
            [`blueCard_[${i}]`]: '',
            card_holder_name: '',
            expiry_date: '',
            blue_card_type: '',
          });
        }
      }
      if (this.profileData?.bce_data?.meta?.card_type === 'QCT') {
        const qctId = this.profileData?.bce_data?.qct_id || '';
        for (let i = 0; i < 6; i++) {
          this.bceQuestionsForm.patchValue({
            [`qct_[${i}]`]: qctId[i] || '',
          });
        }
      } else {
        // Clear QCT fields if switching from QCT to blue card or no card
        for (let i = 0; i < 6; i++) {
          this.bceQuestionsForm.patchValue({
            [`qct_[${i}]`]: '',
          });
        }
      }
      this.bceQuestionsForm.patchValue({
        bce_work_status: value,
        card_type: this.profileData?.bce_data?.meta?.card_type || '',
        blue_card_type: this.profileData?.bce_data?.meta?.blue_card_type || '',
        prefered_location:
          this.profileData?.bce_data?.meta?.prefered_location || '',
        personal_email: this.profileData?.bce_data?.meta?.personal_email || '',
        right_to_work: this.profileData?.bce_data?.meta?.right_to_work || '',
        about_interest: this.profileData?.bce_data?.meta?.about_interest || '',
        bce_roles: this.profileData?.bce_data?.meta?.bce_roles || '',
        interested_role:
          this.profileData?.bce_data?.meta?.interested_role || [],
        // Safeguarding questions
        negative_notice:
          this.profileData?.bce_data?.meta?.negative_notice || '',
        suspended_registration:
          this.profileData?.bce_data?.meta?.suspended_registration || '',
        abused: this.profileData?.bce_data?.meta?.abused || '',
        accused: this.profileData?.bce_data?.meta?.accused || '',
        substantiated: this.profileData?.bce_data?.meta?.substantiated || '',
        criminal: this.profileData?.bce_data?.meta?.criminal || '',
        all_questions: this.profileData?.bce_data?.meta?.all_questions || '',
        // Multiple choice
        teachingLevels: this.profileData?.bce_data?.meta?.teachingLevels || [],
        subject: this.profileData?.bce_data?.meta?.subject || [],
      });

      // BCE file logic: if file exists, clear validator and show name; else, require upload
      const bceFile = this.profileData?.bce_data?.file;
      const fileControl = this.bceQuestionsForm.get('file');
      if (bceFile && fileControl) {
        fileControl.clearValidators();
        fileControl.updateValueAndValidity();
        this.bceFileName = bceFile.split('/').pop();
        this.bceQuestionsForm.patchValue({ file: '' }); // keep form value empty, but not required
      } else if (fileControl) {
        fileControl.setValidators([Validators.required]);
        fileControl.updateValueAndValidity();
        this.bceFileName = '';
      }
      this.bsModalRef = this.modalService.show(this.bceQuestionsModal, {
        class: 'modal-lg',
        backdrop: 'static',
      });
      // Add handler to restore state when modal closes
      const subscription = this.bsModalRef.onHide?.subscribe(() => {
        // Only restore if not saved
        if (this.bce_work_status !== this.originalBceWorkStatus && !this.bceQuestionsForm.dirty) {
          this.bce_work_status = this.originalBceWorkStatus;
        }
        subscription?.unsubscribe();
      });
      this.step = 1; // Always start at step 1
    }
  }
  openNSWVerificationModal() {
    this.bsModalRef = this.modalService.show(this.nswVerificationFormModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }

  openQLDVerificationModal() {
    // this.QCTRegistrationForm.patchValue({
    //   employee_number: this.profileData?.qld_data?.employee_number,
    // });
    this.attemptCount = this.profileData?.qld_data?.meta?.verification_attempts,
      // this.EQVerificationStatus = this.profileData?.qld_data?.employee_number ? true : false;

      this.openQCTRegistrationConfirmationModal();

    // this.bsModalRef = this.modalService.show(this.QCTRegistrationFormModal, {
    //   class: 'modal-lg qct-registration-modal',
    //   backdrop: 'static',
    // });
  }

  submitQLDNoQCT() {
    this.bsModalRef.hide();
  }

  submitHasQCTRegistrationForm() {
    if (this.QCTRegistrationForm.invalid) {
      this.QCTRegistrationForm.markAllAsTouched();
      return;
    } else {
      this.ngxService.start();
      const dobValue = this.QCTRegistrationForm.value.dob;
      let formattedDob = dobValue;
      // Only transform if not already in dd/MM/YYYY format
      if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dobValue)) {
        formattedDob = new DatePipe('en-US').transform(dobValue, 'dd/MM/yyyy') || dobValue;
      }
      this.QCTRegistrationForm.patchValue({
        dob: formattedDob,
      });
      this.ProfileService.qldVerificationAPI(this.QCTRegistrationForm.value).subscribe({
        next: (res: any) => {
          this.ngxService.stop();
          this.attemptCount = res.attempts;
          if (res.status) {
            this.teacherStatus = res.is_contract;
            this.bsModalRef.hide();
            this.bsModalRef = this.modalService.show(this.QCTRegistrationConfirmationModal, {
              class: 'modal-md',
              backdrop: 'static',
            });
          } else {
            if (res.is_conflict) {
              this.bsModalRef.hide();
              this.bsModalRef = this.modalService.show(this.AccountConflictModal, {
                class: 'modal-md',
                backdrop: 'static',
              });
              return;
            }
            if (res.attempts >= 3) {
              this.bsModalRef.hide();
              this.bsModalRef = this.modalService.show(this.AccountNotFoundModal, {
                class: 'modal-md',
                backdrop: 'static',
              });
              return;
            }
            if (res.is_validation_error) {
              this.toastr.error(res.message || 'QCT Verification failed');
              return;
            }
            // this.toastr.error(res.message || 'QCT Verification failed');
          }
        },
        error: (err) => {
          this.ngxService.stop();
          if (err.status === 0) {
            // Covers 504, CORS, network issues
            this.toastr.error('Server not responding or network issue. Please try again');
          }
          else if (err.status === 504) {
            this.toastr.error('Server timeout');
          }
          else {
            this.toastr.error(err.message || 'Something went wrong');
          }
        },
      });
    }
  }

  // Simple helper to check error visibility
  isInvalid(controlName: string): boolean {
    const control = this.QCTRegistrationForm.get(controlName);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
  private parseApiDateToNgbDateStruct(dateStr: string): { year: number, month: number, day: number } | null {
    if (!dateStr) return null;
    const [day, monthStr, year] = dateStr.split(' ');
    const month = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ].indexOf(monthStr) + 1;
    if (month > 0) {
      return { year: Number(year), month, day: Number(day) };
    }
    return null;
  }
  submitNSWFinal() {
    this.ngxService.start();
    this.nswNesaError = '';
    if (this.nswNesaAnswer === 'Yes') {
      // Validate all required fields
      if (!this.nswNesaFirstName || !this.nswNesaLastName || !this.nswNesaDob || !this.nswNesaId || !this.nswNesaTnc || !this.nswNesaPrivacy) {
        this.nswNesaError = 'Please fill all fields and agree to the terms and privacy policy.';
        this.toastr.error(this.nswNesaError);
        return;
      }
      // Prepare data to send with correct backend keys
      // Format dob as yyyy-mm-dd if it's an object
      let dobFormatted: any = this.nswNesaDob;
      if (
        dobFormatted &&
        typeof dobFormatted === 'object' &&
        'year' in dobFormatted &&
        'month' in dobFormatted &&
        'day' in dobFormatted
      ) {
        const y = (dobFormatted as { year: number; month: number; day: number }).year;
        const m = (dobFormatted as { year: number; month: number; day: number }).month.toString().padStart(2, '0');
        const d = (dobFormatted as { year: number; month: number; day: number }).day.toString().padStart(2, '0');
        dobFormatted = `${d}/${m}/${y}`;
      }
      const payload = {
        doe_nesa_id: this.nswNesaId,
        doe_type: 'NESA',
        dob: dobFormatted,
        first_name: this.nswNesaFirstName,
        last_name: this.nswNesaLastName
      };
      this.ProfileService.nswVerificationAPI(payload).subscribe({
        next: (res: any) => {
          if (res.status) {
            this.loadProfileAPI();
            this.toastr.success(res.message || 'NSW NESA details saved');
            this.bsModalRef.hide();
          } else {
            this.ngxService.stop();
            this.toastr.error(res.message || 'Failed to save NSW NESA details');
          }
        },
        error: (err: any) => {
          this.ngxService.stop();
          this.toastr.error(err.message || 'Failed to save NSW NESA details');
        },
      });
    } else {
      const payload = {
        doe_nesa_id: '',
        doe_type: 'WWCC',
        dob: '',
        first_name: '',
        last_name: ''
      };
      this.ProfileService.nswVerificationAPI(payload).subscribe({
        next: (res: any) => {
          if (res.status) {
            this.loadProfileAPI();
            this.bsModalRef.hide();
          } else {
            this.ngxService.stop();
            this.toastr.error(res.message || 'Failed to save NSW NESA details');
          }
        },
        error: (err: any) => {
          this.ngxService.stop();
          this.toastr.error(err.message || 'Failed to save NSW NESA details');
        },
      });
      // No selected, just close modal or handle as needed
    }
  }
  updateNSWVerification: boolean = false;
  openNSWVerificationUpdateModal() {
    this.updateNSWVerification = true;
    this.nswNesaFirstName = this.profileData?.teacher_properties?.nsw_data?.doe_details.first_name || '';
    this.nswNesaLastName = this.profileData?.teacher_properties?.nsw_data?.doe_details.last_name || '';
    this.nswNesaDob = this.parseApiDateToNgbDateStruct(this.profileData?.teacher_properties?.nsw_data?.doe_details.dob || null);
    this.nswNesaId = this.profileData?.teacher_properties?.nsw_data?.doe_details?.nesa_id || '';
    this.nswNesaAnswer = 'Yes'
    this.nswNesaTnc = true;
    this.nswNesaPrivacy = true;

    this.bsModalRef = this.modalService.show(this.nswNesaModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }
  submitNSW(response: 'Y' | 'N' | 'S') {
    var data = {
      status: response,
    };
    this.ngxService.start();
    if (response !== 'Y') {
      this.ProfileService.nswVerificationConfirmAPI(data).subscribe({
        next: (res: any) => {
          if (res.status) {
            if (response === 'N') {
              this.loadProfileAPI(false, 'loadMixpanel');
              this.bsModalRef.hide();
              return;
            } else if (response === 'S') {
              this.loadProfileAPI(false, 'loadMixpanel');
              this.bsModalRef.hide();
            }
          } else {
            this.ngxService.stop();
            this.toastr.error(res.message || 'Failed to update verification');
          }
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to update verification');
          this.ngxService.stop();
        },
      });
    } else {
      this.bsModalRef.hide();
      this.ngxService.stop();
      this.bsModalRef = this.modalService.show(this.nswNesaModal, {
        class: 'modal-md',
        backdrop: 'static',
      });
    }



  }

  // goToPreviousStep() {
  //   if (this.onboardingStep > 1) {
  //     this.onboardingStep--;
  //     this.openStepModal(this.onboardingStep);
  //   }
  // }

  goToNextStep() {
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
    setTimeout(() => {
      this.openNextIncompleteModal();
    }, 1000);
  }
  openNextIncompleteModal() {
    const mandatory = this.profileData?.percentage_mandatory || {};

    if (!mandatory.personal_detail_mandatory) {
      this.openEditProfileModal();
      return;
    }
    if (!mandatory.consumer_type_mandatory) {
      this.openRoleTypeModal();
      return;
    }
    if (!mandatory.using_cc_to_mandatory) {
      this.openBookingsOnboardingModal();
      return;
    }
    if (!mandatory.right_to_work_mandatory) {
      this.openRightsToWorkModal();
      return;
    }
    // Only block onboarding for Queensland users, not all
    if (
      this.profileData?.bce_data?.bce_work_status === 'S' &&
      !this.profileData?.bce_data?.is_deleted &&
      !this.is_qld_teacher
    ) {
      this.openBceModal('', '');
      return;
    }
    // For other states, skip BCE modal and continue onboarding
    if (!mandatory.experience_mandatory) {
      this.openSkillsModal();
      return;
    }
    if (!mandatory.qualifications) {
      this.openQualificationsModal();
      return;
    }
    if (!mandatory.references) {
      this.openReferencesModal();
      return;
    }
    // All steps completed, do not open any modal

  }
  getYearsList(): number[] {
    return Array.from({ length: 15 }, (_, i) => 2023 + i); // [2010, 2011, ..., 2024]
  }

  handleChildEvent(data: string) {
    this.loadProfileAPI();
  }


  openBookingsOnboardingModal() {
    this.bsModalRef = this.modalService.show(this.bookingsOnboardingModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }
  getNextOnboardingStepNonQld(): number {
    const mandatory = this.profileData?.percentage_mandatory || {};
    // alert(this.using_cc_to_B);
    // // if (!this.using_cc_to_B && this.using_cc_to_B !== undefined && mandatory.using_cc_to_mandatory) {
    // //   this.showOnboarding = false; // Onboarding skipped
    // //   return 0; // Onboarding skipped
    // // }
    // Only block onboarding for Queensland users on BCE modal
    if (
      !mandatory.personal_detail_mandatory ||
      !mandatory.using_cc_to_mandatory ||
      !mandatory.consumer_type_mandatory ||
      !mandatory.right_to_work_mandatory ||
      (!this.is_qld_teacher && this.profileData?.bce_data.bce_work_status === 'S' && !this.profileData?.bce_data?.is_deleted)
    ) return 1;
    if (!mandatory.experience_mandatory) return 2;
    if (!mandatory.qualifications) return 3;
    if (!mandatory.references) return 4;
    return 5; // All completed
  }



  get isOnboardingIncomplete(): boolean {
    const mandatory = this.profileData?.percentage_mandatory || {};
    return (
      !mandatory.personal_detail_mandatory ||
      !mandatory.using_cc_to_mandatory ||
      !mandatory.consumer_type_mandatory ||
      !mandatory.right_to_work_mandatory ||
      !mandatory.experience_mandatory ||
      !mandatory.qualifications ||
      !mandatory.references
    );
  }
  openNonQldOnboardingStep(step: number) {
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
    setTimeout(() => {
      this.onboardingStep = step;
      // New onboarding flow: remove case 1, make case 2 the new step 1
      // and show bookingsOnboardingModal after roleTypeModal
      switch (step) {
        case 1:
          const mandatory = this.profileData?.percentage_mandatory || {};
          if (!mandatory.personal_detail_mandatory) {
            this.bsModalRef = this.modalService.show(this.editProfileModal, { class: 'modal-lg', backdrop: 'static' });
          } else if (!mandatory.using_cc_to_mandatory) {
            // After roleTypeModal, show bookingsOnboardingModal
            this.bsModalRef = this.modalService.show(this.bookingsOnboardingModal, { class: 'modal-md', backdrop: 'static' });
          } else if (!mandatory.consumer_type_mandatory) {
            this.bsModalRef = this.modalService.show(this.roleTypeModal, { class: 'modal-lg', backdrop: 'static' });
          } else if (!mandatory.right_to_work_mandatory) {
            this.bsModalRef = this.modalService.show(this.rightsToWorkModal, { class: 'modal-lg', backdrop: 'static' });
          } else if (this.profileData?.bce_data.bce_work_status === 'S' && !this.profileData?.bce_data.is_deleted && !this.is_qld_teacher) {
            this.openBceModal('', '');
          }
          break;
        case 2:
          this.bsModalRef = this.modalService.show(this.skillsModal, { class: 'modal-lg', backdrop: 'static' });
          break;
        case 3:
          this.bsModalRef = this.modalService.show(this.qualificationsModal, { class: 'modal-lg', backdrop: 'static' });
          break;
        case 4:
          this.bsModalRef = this.modalService.show(this.referenceModal, { class: 'modal-lg', backdrop: 'static' });
          break;
      }
    }, 1000); // 1000ms delay for modal animation
  }

  openOnboardingStep(step: number) {
    this.openQCTRegistrationConfirmationModal();
  }

  // Open the correct modal for the step
  triggerOnboardingFlow() {
    if (!this.profileData?.percentage_mandatory?.personal_detail_mandatory) {
      const step = this.getNextOnboardingStepNonQld();
      if (step > 0) {
        this.openNonQldOnboardingStep(step)
      }
    } else if (!this.profileData?.percentage_mandatory?.is_show_qld_popup) {
      this.openOnboardingStep(3);
    } else {
      const step = this.getNextOnboardingStepNonQld();
      if (step > 0) {
        this.openNonQldOnboardingStep(step);
      }
    }
  }
  closeBookingsAndContinue() {
    this.bsModalRef.hide();
    setTimeout(() => {
      this.triggerOnboardingFlow();
    }, 1000); // Delay ensures modal is closed before next opens
  }
  saveBookingsOnboarding() {
    const payload = {
      using_cc_to_B: this.using_cc_to_B ? 1 : 0,
      from: 'usingCCToDetails',
    };

    this.ngxService.start();
    this.ProfileService.saveProfileAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message || 'Profile updated successfully');
          if (this.bsModalRef) {
            this.bsModalRef.hide();
          }
          window.location.replace(`${window.location.origin}/login?refresh=true&from=profileBookings`);
          // this.showOnboarding = this.isOnboardingIncomplete;
          // // If bookings are ON, continue onboarding as usual
          // this.onboardingStep = 1;
          // setTimeout(() => {
          //   this.loadProfileAPI();
          // }, 1000);
        } else {
          this.ngxService.stop();
          this.toastr.error(res.message || 'Failed to update profile');
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.message || 'Failed to update profile');
      },
    });
  }

  mixpanelCall() {
    this.commonService.getUserData('').subscribe({
      next: (res) => {
        localStorage.setItem('userData', JSON.stringify(res.data));
        this.teachLocalData = JSON.parse(localStorage.getItem('userData') || '{}');
        this.is_qld_teacher = this.teachLocalData?.properties?.is_qld_teacher || false;
      },
      error: (err) => {
        console.error('Error fetching user data:', err);
        this.ngxService.stop();
        this.sharedService.announcement.next(
          'An error occurred while fetching user data.'
        );
      },
    });
  }
  openCompleteProfile(from: boolean) {
    if (!from) {
      this.loadProfileAPI(true, 'loadMixpanel');
    } else {
      this.loadProfileAPI(false, 'loadMixpanel');
    }
    // this.action = 'OPEN_Qld_PROFILE';
    localStorage.setItem('QLDOnboardning', 'true');
  }

  // checkEqId() {
  //   this.ngxService.start();
  //   console.log('checkEqId called');
  //   this.ProfileService.checkEqIdAPI(this.QCTRegistrationForm.value.eq_number).subscribe({
  //     next: (res: any) => {
  //       this.ngxService.stop();
  //       this.attemptCount = res.attempts;
  //       if (res.status) {
  //         // console.log('EQ ID verified successfully');
  //         this.EQVerificationStatus = true;
  //         this.toastr.success(res.message);
  //       } else {
  //         if (res.is_conflict) {
  //           this.bsModalRef.hide();
  //           this.bsModalRef = this.modalService.show(this.AccountConflictModal, {
  //             class: 'modal-md',
  //             backdrop: 'static',
  //           });
  //           return;
  //         }
  //         if (res.attempts >= 3) {
  //           this.bsModalRef.hide();
  //           this.bsModalRef = this.modalService.show(this.AccountNotFoundModal, {
  //             class: 'modal-md',
  //             backdrop: 'static',
  //           });
  //           return;
  //         }
  //         this.toastr.error(res.message || 'QCT Verification failed');
  //       }
  //     },
  //     error: (err: any) => {
  //       this.toastr.error(err.message || 'Failed to check EQ ID status');
  //       this.ngxService.stop();
  //     },
  //   });
  // }

  ReqTracerHelper() {
    // console.log('ReqTracerHelper called', this.profileData);
    // this.bsModalRef.hide();
    // this.loadProfileAPI();
    // return;
    const payload = {
      qld_teacher_id: this.profileData?.qld_data?.id,
    };
    this.ngxService.start();
    this.ProfileService.requestTracerHelpAPI(payload).subscribe({
      next: (res: any) => {
        this.ngxService.stop();
        if (res.status) {
          this.bsModalRef.hide();
          this.ngxService.stop();
          this.toastr.success(res.message || 'Request traced successfully');
          setTimeout(() => {
            this.loadProfileAPI(false, 'loadMixpanel');
          }, 300);
        } else {
          this.toastr.error(res.message || 'Failed to trace request');
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.message || 'Failed to trace request');
      },
    });
  }

  handlePageData(data: any) {
    // Store the page data for later use, e.g. pagination or display
    this.pageData = data;
    // Optionally, update the UI or trigger other logic if needed
    // Example: this.obsArray.next(data.consumer_list || []);
  }
  pageData: any;
  onDateInputKeyDown(event: KeyboardEvent, datepicker: any) {
    if (event.key === 'Enter') {
      datepicker.toggle();
      event.preventDefault();
    }
  }
  clearSinglePicker() {
    this.rightsToWorkForm.patchValue({ work_start_date: null });
    this.nswNesaDob = null;
  }
  /**
  * Remove a row (qualification, attachment, reference, accreditation, workexperience, skills)
  * @param type remove_qualification, remove_attachments, remove_references, remove_accreditation, remove_workexperience, remove_skills
  * @param index index of the item to remove
  */
  removeRow(type: string, index: number) {
    const payload = { remove: type, index };
    this.ngxService.start();
    this.ProfileService.profileDeleteAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message || 'Removed successfully');
          this.loadProfileAPI();
        } else {
          this.toastr.error(res.message || 'Failed to remove');
        }
        this.ngxService.stop();
      },
      error: (err: any) => {
        this.toastr.error(err.message || 'Failed to remove');
        this.ngxService.stop();
      },
    });
  }

  @ViewChild('videoIntroModal') videoIntroModal: any;
  openVideoModal(videoID: any) {
    if (videoID == null || videoID == undefined || videoID == '') {
      this.bsModalRef = this.modalService.show(this.videoIntroModal, {
        class: 'modal-lg',
        backdrop: 'static',
      });
    } else {
      this.bsModalRef = this.modalService.show(this.videoIntroModal, {
        class: 'modal-lg',
        backdrop: 'static',
      });
      this.videoIntroForm.patchValue({
        video_intro_link: this.introVideo.url,
      });
      this.onVideoIntroLinkChange();
    }
  }

  @ViewChild('introVideoRemoveConfirmation') introVideoRemoveConfirmation: any;
  openIntroVideoRemoveConfirmation() {
    this.bsModalRef = this.modalService.show(this.introVideoRemoveConfirmation, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }
  videoIntroForm: FormGroup = this.fb.group({
    video_intro_link: ['', [Validators.required]],
  });
  videoMeta: any = null;
  videoError: string = '';
  videoLoading: boolean = false;

  // Helper: parse YouTube ID
  private getYouTubeId(url: string): string | null {
    if (!url) return null;
    const cleanedUrl = url.trim();
    const match = cleanedUrl.match(
      /(?:youtu\.be\/|youtube\.com\/(?:shorts\/|embed\/|v\/|live\/|watch\?v=|watch\?.+&v=))([\w-]{11})/
    );
    return match ? match[1] : null;
  }

  // Helper: parse Vimeo ID
  private getVimeoId(url: string): string | null {
    const match = url.match(/(?:vimeo\.com\/(?:video\/)?)(\d+)/);
    return match ? match[1] : null;
  }

  // Fetch video metadata and validate duration
  onVideoIntroLinkChange() {
    this.videoMeta = null;
    this.videoError = '';
    const url = this.videoIntroForm.value.video_intro_link;
    if (!url) return;
    this.videoLoading = true;
    // YouTube
    const ytId = this.getYouTubeId(url);
    console.log('Parsed YouTube ID:', ytId);
    if (ytId) {
      // Use oEmbed for title/thumbnail only, cannot validate duration without API key
      fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${ytId}&format=json`)
        .then(r => r.json())
        .then(meta => {
          this.videoMeta = {
            type: 'youtube',
            id: ytId,
            title: meta.title,
            thumbnail: meta.thumbnail_url,
            duration: null, // unknown
            url,
          };
          // No error shown to user, just store meta
          this.videoLoading = false;
        })
        .catch(() => {
          this.videoError = 'Invalid YouTube link.';
          this.videoLoading = false;
        });
      return;
    }
    // Vimeo
    const vimeoId = this.getVimeoId(url);
    if (vimeoId) {
      fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${vimeoId}`)
        .then(r => r.json())
        .then(meta => {
          // Vimeo oEmbed gives duration in seconds
          this.videoMeta = {
            type: 'vimeo',
            id: vimeoId,
            title: meta.title,
            thumbnail: meta.thumbnail_url,
            duration: meta.duration,
            url,
          };
          this.videoLoading = false;
        })
        .catch(() => {
          this.videoError = 'Invalid Vimeo link.';
          this.videoLoading = false;
        });
      return;
    }
    this.videoError = 'Please enter a valid YouTube or Vimeo link.';
    this.videoLoading = false;
  }

  // Save handler for video intro
  saveVideoIntro() {
    if (!this.videoMeta || this.videoError) return;
    // Send { link, title, thumbnail, duration } to backend as needed
    let embedUrl = this.videoMeta.url;
    // If YouTube, convert watch link to embed link
    if (this.videoMeta.type === 'youtube') {
      const ytId = this.getYouTubeId(this.videoMeta.url);
      if (ytId) {
        embedUrl = `https://www.youtube.com/embed/${ytId}`;
      }
    }

    // If Vimeo, convert to embed link
    if (this.videoMeta.type === 'vimeo') {
      const vimeoId = this.getVimeoId(this.videoMeta.url);
      if (vimeoId) {
        embedUrl = `https://player.vimeo.com/video/${vimeoId}`;
      }
    }
    const payload = {
      video_intro_link: embedUrl,
      video_intro_title: this.videoMeta.title,
      video_intro_thumbnail: this.videoMeta.thumbnail,
      video_intro_duration: this.videoMeta.duration,
      from: 'video_intro'
    };
    this.ngxService.start();
    this.ProfileService.saveProfileAPI(payload)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            this.toastr.success('Video intro saved!');
            this.bsModalRef.hide();
            let currentUrl = this._router.url;
            this._router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                this._router.navigate([currentUrl]);
              });
          } else {
            this.toastr.error(res.message || 'Failed to save video intro');
          }
          this.ngxService.stop();
        },
        error: (err: any) => {
          this.toastr.error('something went wrong');
          this.ngxService.stop();
          console.log(err);
        },
      });
  }
  removeVideoIntro() {
    const payload = {
      remove: 'video_intro',
    };
    this.ngxService.start();
    this.ProfileService.profileDeleteAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success('Video intro removed!');
          this.introVideo = null;
          this.bsModalRef?.hide();
          let currentUrl = this._router.url;
          this._router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => {
              this._router.navigate([currentUrl]);
            });
        } else {
          this.toastr.error(res.message || 'Failed to remove video intro');
        }
        this.ngxService.stop();
      },
      error: (err: any) => {
        this.toastr.error('Something went wrong');
        this.ngxService.stop();
      },
    });
  }

  openQCTRegistrationConfirmationModal() {
    // console.log('Opening QCT Registration Confirmation Modal', this.profileData);
    if (!this.profileData?.qld_data?.meta?.verification_attempts) {
      this.QCTRegistrationForm.patchValue({
        first_name: this.profileData?.qld_data?.first_name,
        last_name: this.profileData?.qld_data?.last_name,
        employee_number: this.profileData?.qld_data?.employee_id,
        dob: this.profileData?.qld_data?.dob ? new DatePipe('en-US').transform(
          this.profileData?.qld_data?.dob,
          'dd/MM/YYYY'
        ) : '',
        qct_number: this.profileData?.qld_data?.qct_number,
      });
    }
    this.bsModalRef = this.modalService.show(this.QCTRegistrationFormModal, {
      class: 'modal-lg qct-registration-modal',
      backdrop: 'static',
      keyboard: false,
    });
  }
  closeQldModal() {
    this.ngxService.start();
    let data = {
      status: 'N',
    }
    this.ProfileService.qldStatusUpdate(data).subscribe({
      next: (res: any) => {
        if (res.status) {
          // this.toastr.success(res.message || 'QCT status updated');
          this.bsModalRef?.hide();
          let currentUrl = this._router.url;
          this._router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => {
              this._router.navigate([currentUrl]);
            });
        } else {
          this.ngxService.stop();
          // this.toastr.error(res.message || 'Failed to update QCT status');
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
      },
    });
  }
  saveCairnsData() {
    this.ngxService.start();
    const payload = {
      from: "group_custom_fields",
      "Cairns_0_CNS Payroll ID": this.custom_fields_Cairns_0_CNS,
      "Cairns_0_Previous Surname": this.custom_fields_Cairns_0_Previous,
      "Cairns_0_Alternative Work Email Address": this.custom_fields_Cairns_0_Alternative,
      "plan_to_work_group_Cairns": this.plan_to_work_group,
    };

    this.ProfileService.saveProfileAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message || 'Cairns details saved successfully');
          this.loadProfileAPI();
        } else {
          this.ngxService.stop();
          this.toastr.error(res.message || 'Failed to save Cairns details');
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.message || 'Failed to save Cairns details');
      },
    });
  }

  onPlanToWorkGroupChange(value: boolean) {
    if (value === false) {
      this.saveCairnsData();
    }
  }
}